//import './style.scss';
import './stylenew.scss';
import './DetailDashboardstyle.scss';
import './boilerplate.scss';
import '../../js/app.js';
import { useEffect, useRef } from "react";
import { useState } from 'react';
import { IFeature } from '@esri/arcgis-rest-types';
import { MapArea } from "./components/MapArea";
import { IRelatedRecordGroup } from '@esri/arcgis-rest-feature-layer';
import QueryService from '../../shared/queryService';
import ConfigService from '../../shared/configService';
import { FieldInfo, IDashboard, IReportRb, IReportRbJobs, IReferenceTables, IReportMonitoring } from '../../models/IConfig';
import IReport from '../../models/IReport';
import Utils from '../../shared/utils';
import { useTranslation } from "react-i18next";
import { IReportFinancialFlows, IReportMain, IGADM_0, IGADM_1, IReportPolicies } from '../../models/IConfig';
import Gauge from "react-svg-gauge";
import { IReportLocation } from './models/reports';
import { Chart as ChartJS, CategoryScale, LinearScale, ArcElement, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { useLocation } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import queryString from 'query-string';
import DashboardUtils from './dashboardUtils';
import AggregationMap from './components/AggregationMap';
import ActivitiesMap from './components/ActivitiesMap';
import SectionInterventionTypesList from './components/SectionInterventionTypesList';
import SectionCo2SystemsList from './components/SectionCo2SystemsList';
import { IRefTierFeature, IRefPlanningStatusFeature, IRefPlanningObservScalesFeature, IRefPlanningApproachScaleFeature, IRefMonitoringApproachScaleFeature, IRefMonitoringTrackedElemFeature } from '../reports/EditReport/models/IRefFeature';
import React from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { BarChart, GaugeChart } from 'echarts/charts';
import {
    GridComponent,
    TooltipComponent,
    TitleComponent,
    DatasetComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    BarChart,
    GaugeChart,
    CanvasRenderer,
]);

ChartJS.register(
    CategoryScale,
    LinearScale,
    ArcElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const DetailDashboard = (props: any) => {

    const { t } = useTranslation('detaildashboard');
    const mapAreaRef = useRef<any>();

    const gadm0Config: IGADM_0 = ConfigService.getConfig().agol.gadmLayers.gadm_0;
    const gadm1Config: IGADM_1 = ConfigService.getConfig().agol.gadmLayers.gadm_1;

    interface ILocalState {
        loading: boolean,
        queryParams: any,
        reportLocation: IReportLocation | undefined,
        activitiesPointFeatures: IFeature[],
        activitiesPolygonFeatures: IFeature[],
        gadmFeatures: IFeature[],
        reloadKey: number,
        referenceLabels: {
            REF_TIERS: any,
            REF_PLANNING_STATUS: any,
            REF_PLANNING_OBSERVATION_SCALE: any,
            REF_PLANNING_APPROACH_SCALE: any,
            REF_MONITORING_TRACKED_ELEMENTS: any,
            REF_MONITORING_APPROACH_SCALE: any
        }
    }

    interface IDataState {
        reports: IReport[],
        countries: IFeature[],
        states: IFeature[],
        selectedGid: string,
        selectedLocation: string,
        selectedYear: string,
        ha_pledged: number,
        pledge_year: number,
        baseline_year: number,
        sum_ha_under_resto: number,
        sum_co2_sequestered: number,
        sum_invested: number,
        sum_eco_jobs_created: number,
        display_policies: boolean,
        display_technical_planning: boolean,
        display_financial_flows: boolean,
        display_monitoring_systems: boolean,
        display_area_of_land: boolean,
        display_climate: boolean,
        display_biodiversity: boolean,
        display_economy: boolean,
        reportid: string
    }

    interface IOptionsState {
        listReportCountries: IReportLocation[],
        listReportStates: IReportLocation[],
        years: number[],
    }

    const initialDataState = {
        reports: [],
        countries: [],
        states: [],
        selectedGid: "",
        selectedLocation: "",
        selectedYear: "",
        ha_pledged: 0,
        pledge_year: 0,
        baseline_year: 0,
        sum_ha_under_resto: 0,
        sum_co2_sequestered: 0,
        sum_invested: 0,
        sum_eco_jobs_created: 0,
        display_policies: false,
        display_technical_planning: false,
        display_financial_flows: false,
        display_monitoring_systems: false,
        display_area_of_land: false,
        display_climate: false,
        display_biodiversity: false,
        display_economy: false,
        reportid: ""
    };
    const [dataState, setDataState] = useState<IDataState>({
        reports: [],
        countries: [],
        states: [],
        selectedGid: "",
        selectedLocation: "",
        selectedYear: "",
        ha_pledged: 0,
        pledge_year: 0,
        baseline_year: 0,
        sum_ha_under_resto: 0,
        sum_co2_sequestered: 0,
        sum_invested: 0,
        sum_eco_jobs_created: 0,
        display_policies: false,
        display_technical_planning: false,
        display_financial_flows: false,
        display_monitoring_systems: false,
        display_area_of_land: false,
        display_climate: false,
        display_biodiversity: false,
        display_economy: false,
        reportid: ""
    });

    const [optionsState, setOptionsState] = useState<IOptionsState>({
        listReportCountries: [],
        listReportStates: [],
        years: []
    });

    const [state, setState] = useState<ILocalState>({
        loading: false,
        queryParams: queryString.parse(useLocation().search),
        reportLocation: undefined,
        activitiesPointFeatures: [],
        activitiesPolygonFeatures: [],
        gadmFeatures: [],
        reloadKey: new Date().getTime(),
        referenceLabels: {
            REF_TIERS: {},
            REF_PLANNING_STATUS: {},
            REF_PLANNING_OBSERVATION_SCALE: {},
            REF_PLANNING_APPROACH_SCALE: {},
            REF_MONITORING_TRACKED_ELEMENTS: {},
            REF_MONITORING_APPROACH_SCALE: {}
        }
    });

    const [sectionData, setSectionData] = useState({
        relatedRB: [],
        c02EstimationSystems: [],
        keyEcosystem: {
            attributes: []
        },
        keyIntervention: {
            attributes: []
        },
        policies: {
            attributes: [],
            chartConfig: {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Policies',
                            data: [],
                            backgroundColor: 'rgb(87, 204, 171)',
                        }
                    ],
                    total: 0
                },
                options: {
                    responsive: true,
                    ticks: {
                        precision: 0
                    },
                    plugins: {
                        legend: {
                            display: false,
                            position: 'right' as const,
                        },
                        title: {
                            display: true,
                            position: 'bottom' as const,
                            text: 'Number of policies by year enacted'
                        }
                    }
                }
            },
            chartConfigSecond: {

                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Number of policies by responsible institution",
                            data: [],
                            backgroundColor: [],
                            borderColor: [],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    type: 'bar',
                    indexAxis: 'y' as const,
                    elements: {
                        bar: {
                            borderWidth: 2,
                        },
                    },
                    responsive: true,
                    ticks: {
                        precision: 0
                    },
                    plugins: {
                        legend: {
                            display: false,
                            position: 'right' as const,
                        },
                        title: {
                            display: true,
                            position: 'bottom' as const,
                            text: 'Number of policies by responsible institution'
                        }
                    },
                    scales: {
                        xAxes: {
                            grid: { display: false }
                        },
                        yAxes: {
                            grid: { display: false },
                            beginAtZero: true,
                            ticks: {
                                autoSkip: false
                            }
                        }
                    }
                }
            }
        },
        technicalPlanning: {
            attributes: [],
            refattributes: []
        },
        financialFlows: {
            attributes: [],
            chartConfig: {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                    ],
                    total: 0
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            display: false,
                            position: 'right' as const,
                        },
                        title: {
                            display: false,
                            text: ''
                        }
                    },
                    interaction: {
                        mode: 'index' as const,
                        intersect: false,
                    },
                    scales: {
                        x: {
                            stacked: true,
                        },
                        y: {
                            stacked: true,
                        },
                    }
                }
            }
        },
        monitoringSystems: {
            attributes: []
        },
        areaOfLand: {
            attributes: [],
            pieChartConfig: {
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Number of hectares under restoration by intervention type",
                            data: [],
                            backgroundColor: [],
                            borderColor: [],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'right' as const,
                        },
                        title: {
                            display: true,
                            position: 'bottom' as const,
                            text: 'Number of hectares under restoration by intervention type.'
                        }
                    }
                }
            }
        },
        climate: {
            attributes: []
        },
        biodiversity: {
            attributes: [],
            chartConfigBiodiversity: {
                type: 'bar',
                width: 650,
                height: 350,
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Percentage of area under restoration',
                            data: [],
                            backgroundColor: 'rgb(87, 204, 171)',
                        }
                    ],
                    total: 0
                },
                options: {
                    responsive: true,
                    ticks: {
                        precision: 0
                    },
                    plugins: {
                        legend: {
                            display: false,
                            position: 'right' as const,
                        },
                        title: {
                            display: false,
                            position: 'top' as const,
                            text: 'Percentage of area under restoration'
                        },
                    },
                    width: 650,
                    height: 350,
                },

            },
            pieChartConfig: {
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Ha restoration by area type",
                            data: [],
                            backgroundColor: [],
                            borderColor: [],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'right' as const,
                        },
                        title: {
                            display: true,
                            position: 'bottom' as const,
                            text: 'Ha restoration by area type'
                        }
                    }
                }
            }
        },
        economy: {
            attributes: [],
            pieChartConfig1: {
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Jobs created by type",
                            data: [],
                            backgroundColor: [],
                            borderColor: [],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'right' as const,
                        },
                        title: {
                            display: true,
                            position: 'bottom' as const,
                            text: 'Jobs created by type'
                        }
                    },
                    width: 450,
                    height: 350
                }
            },
            pieChartConfig2: {
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Jobs created by gender",
                            data: [],
                            backgroundColor: [],
                            borderColor: [],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'right' as const,
                        },
                        title: {
                            display: true,
                            position: 'bottom' as const,
                            text: 'Jobs created by gender'
                        }
                    },
                    width: 340,
                    height: 340
                }
            },
            chartConfig: {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                    ],
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            display: false,
                            position: 'right' as const,
                        },
                        title: {
                            display: true,
                            position: 'bottom' as const,
                            text: 'Jobs created by type and by gender'
                        }
                    },
                    interaction: {
                        mode: 'index' as const,
                        intersect: false,
                    },
                    scales: {
                        x: {
                            stacked: true,
                        },
                        y: {
                            stacked: true,
                        },
                    }
                }
            }
        }

    })

    const openAccordionTab = (index: any, id: any) => {
        openPolicyTab(index, id);
    }

    const [showPolicyFullData, setPolicyFullDataShow] = useState(false);
    const [showFinancialFullData, setFinancialFullDataShow] = useState(false);
    const [showTechnicalPlanningFullData, setTechnicalPlanningFullDataShow] = useState(false);
    const [showMonitoringSystemFullData, setMonitoringSystemFullDataShow] = useState(false);
    const [showAreaOfLandFullData, setAreaOfLandFullDataShow] = useState(false);
    const [showClimateFullData, setClimateFullDataShow] = useState(false);
    const [showBiodiversityFullData, setBiodiversityFullDataShow] = useState(false);
    const [showEconomyFullData, setEconomyFullDataShow] = useState(false);

    const config: IDashboard = ConfigService.getConfig().dashboard;
    const reportMainConfig: IReportMain = ConfigService.getConfig().agol.operationalLayers.reportMain;
    const reportPoliciesConfig: IReportPolicies = ConfigService.getConfig().agol.operationalLayers.reportPolicies;
    const reportFinancialFlowsConfig: IReportFinancialFlows = ConfigService.getConfig().agol.operationalLayers.reportFinancialFlows;
    const reportRBConfig: IReportRb = ConfigService.getConfig().agol.operationalLayers.reportRb;
    const reportRbJobsConfig: IReportRbJobs = ConfigService.getConfig().agol.operationalLayers.reportRbJobs;
    const reportMonitoringConfig: IReportMonitoring = ConfigService.getConfig().agol.operationalLayers.reportMonitoring;
    const refTablesConfig: IReferenceTables = ConfigService.getConfig().agol.referenceTables;

    useEffect(() => {
        fillOptions();

        if (props.selectedGID && props.year) {
            const obj: any = { ...optionsState };
            setState(obj);
            fetchData(props.selectedGID, props.year);
        }
    }, []);

    /**
     * Get Activities
     */

    const option = {
        series: [

            {
                type: 'gauge',
                startAngle: 180,
                endAngle: 0,
                min: 0,
                max: dataState.ha_pledged,
                radius: "100%",
                splitNumber: 1,
                itemStyle: {
                    color: 'red',
                    shadowBlur: 0,
                },
                progress: {
                    show: true,
                    roundCap: false,
                    width: 18

                },
                anchor: {
                    show: true,
                    size: 10,
                    itemStyle: {
                        color: '#0d3435',
                        borderWidth: 0
                    }
                },
                pointer: {
                    offsetCenter: [0, '0%'],
                    icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
                    length: '105%',
                    width: 0.5,

                    showAbove: true,
                    itemStyle: {
                        color: '#000',
                        borderType: 'solid',
                        borderCap: "square",
                        borderJoin: 'miter'
                    }
                },
                axisLine: {
                    roundCap: false,
                    lineStyle: {
                        width: 18,

                    }
                },
                axisTick: {
                    show: false,
                    splitNumber: 2,
                    lineStyle: {
                        width: 1,
                        color: '#999'
                    }
                },
                splitLine: {
                    length: 30,
                    distance: -18,
                    lineStyle: {
                        width: 1,
                        color: '#191f3b'
                    }
                },
                axisLabel: {
                    distance: 30,
                    color: '#191f3b',
                    fontSize: 20,
                    formatter: function (label: any) {
                        return (label == 0 || label == dataState.ha_pledged) ? label.toLocaleString() : ""
                    }
                },
                title: {
                    show: false
                },
                detail: {
                    backgroundColor: '#fff',
                    borderColor: '#999',
                    borderWidth: 0,
                    width: '100%',
                    lineHeight: 40,
                    fontSize: 14,
                    height: 40,
                    borderRadius: 8,
                    offsetCenter: [0, '-50%'],
                    valueAnimation: true,
                    font: ["'StevieSansBook', 'sans-serif'"],
                    overflow: "breakAll",
                    formatter: function (value: any) {
                        return ["{a|" + value.toLocaleString() + "}", "{b|HECTARES UNDER \n RESTORATION}"].join("\n\n")
                    },
                    rich: {
                        a: {
                            color: "#191f3b",
                            fontWeight: 600,
                            font: ["'StevieSansBook', 'sans-serif'"],
                            fontSize: 46,
                            lineHeight: 52,
                            padding: [0, 0, 5, 0]

                        },
                        b: {
                            color: "#197058",
                            fontWeight: 500,
                            font: ["'StevieSansBook', 'sans-serif'"],
                            fontSize: 16,
                            lineHeight: 24,
                        }
                    }
                },
                data: [
                    {
                        value: dataState.sum_ha_under_resto,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 0, [{
                                    offset: 0,
                                    color: '#c0d9cf'
                                },
                                {
                                    offset: 1,
                                    color: '#65bea5'
                                }
                            ]
                            )
                        }
                    }
                ]
            },

        ]
    };

    // const data = [
    //     {
    //         value: dataState.ha_pledged,
    //     },
    // ];

    const getActivitiesAndGADM = async (reportLocation: IReportLocation | undefined) => {
        if (reportLocation) {
            const obj: ILocalState = { ...state }
            obj.reportLocation = reportLocation;

            // Activities
            const baseURL = ConfigService.getConfig().agol.operationalLayers.consultURL;
            const ptsFeatures: IFeature[] = await QueryService.queryFeatures(`${baseURL}/${ConfigService.getConfig().agol.operationalLayers.activitiesPoints.index}`, `${ConfigService.getConfig().agol.operationalLayers.activitiesFields.reportId} = '${reportLocation?.reportid}'`, false, '*', '', null, false);
            const polyFeatures: IFeature[] = await QueryService.queryFeatures(`${baseURL}/${ConfigService.getConfig().agol.operationalLayers.activitiesPolygons.index}`, `${ConfigService.getConfig().agol.operationalLayers.activitiesFields.reportId} = '${reportLocation?.reportid}'`, false, '*', '', null, false);

            if (ptsFeatures && ptsFeatures.length) {
                obj.activitiesPointFeatures = ptsFeatures;
            } else if (polyFeatures && polyFeatures.length) {
                obj.activitiesPolygonFeatures = polyFeatures;
            }

            // GADM
            const gadmLayerIndex: number = reportLocation.GID_1 ? ConfigService.getConfig().agol.gadmLayers.gadm_2.index : ConfigService.getConfig().agol.gadmLayers.gadm_1.index;
            const gidField: string = reportLocation.GID_1 ? ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.gid1 : ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.gid0;
            const gidValue: string = reportLocation.GID_1 ? reportLocation.GID_1 : reportLocation.GID_0;

            if (gadmLayerIndex == 1) {
                obj.gadmFeatures = await QueryService.queryGADMFeatures(gadmLayerIndex, '', gidField, gidValue, '', '', true);
            }
            else if (gadmLayerIndex == 2) {
                obj.gadmFeatures = await QueryService.queryGADMFeatures(gadmLayerIndex, '', gidField, gidValue, gidField, gidValue, true);
            }

            obj.reloadKey = new Date().getTime()

            // Ref data
            const tierFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_TIERS.index);
            const planningStatusFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_PLANNING_STATUS.index);
            const planningObservScalesFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_PLANNING_OBSERVATION_SCALE.index);
            const planningApproachScaleFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_PLANNING_APPROACH_SCALE.index);
            const monitoringTrackedElemFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_MONITORING_TRACKED_ELEMENTS.index);
            const monitoringGeoScaleFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_MONITORING_APPROACH_SCALE.index);

            tierFeatures.forEach((feat: IFeature) => {
                const item: IRefTierFeature = feat.attributes as IRefTierFeature;
                obj.referenceLabels.REF_TIERS[item.key_ || ''] = item.value;
            });

            planningStatusFeatures.forEach((feat: IFeature) => {
                const item: IRefPlanningStatusFeature = feat.attributes as IRefPlanningStatusFeature;
                obj.referenceLabels.REF_PLANNING_STATUS[item.key_ || ''] = item.value;
            });

            planningObservScalesFeatures.forEach((feat: IFeature) => {
                const item: IRefPlanningObservScalesFeature = feat.attributes as IRefPlanningObservScalesFeature;
                obj.referenceLabels.REF_PLANNING_OBSERVATION_SCALE[item.key_ || ''] = item.value;
            });

            planningApproachScaleFeatures.forEach((feat: IFeature) => {
                const item: IRefPlanningApproachScaleFeature = feat.attributes as IRefPlanningApproachScaleFeature;
                obj.referenceLabels.REF_PLANNING_APPROACH_SCALE[item.key_ || ''] = item.value;
            });

            monitoringTrackedElemFeatures.forEach((feat: IFeature) => {
                const item: IRefMonitoringTrackedElemFeature = feat.attributes as IRefMonitoringTrackedElemFeature;
                obj.referenceLabels.REF_MONITORING_TRACKED_ELEMENTS[item.key_ || ''] = item.value;
            });

            monitoringGeoScaleFeatures.forEach((feat: IFeature) => {
                const item: IRefMonitoringApproachScaleFeature = feat.attributes as IRefMonitoringApproachScaleFeature;
                obj.referenceLabels.REF_MONITORING_APPROACH_SCALE[item.key_ || ''] = item.value;
            });

            setState(obj);
        }
    }

    const fetchData = async (gid: string, year: string) => {
        await setFullDataVisibility(false);

        Utils.setStateValue("loading", true, state, setState);

        const reportLocation: IReportLocation | undefined = await findReport(gid, year);

        if (reportLocation) {
            const stats = await fetchStatisticsData(reportLocation, year, gid);

            const obj: IDataState = { ...dataState };
            obj.selectedLocation = reportLocation.title;
            obj.selectedYear = year;
            obj.countries = stats.countries;
            obj.reports = stats.reports;
            obj.states = stats.states;
            obj.selectedGid = reportLocation.gid;
            obj.ha_pledged = reportLocation.ha_pledged;
            obj.pledge_year = reportLocation.pledge_start;
            obj.baseline_year = reportLocation.baseline_year;
            obj.sum_ha_under_resto = stats.sum_ha_under_resto;
            obj.sum_co2_sequestered = stats.sum_co2_sequestered?.toLocaleString();
            obj.sum_invested = stats.sum_invested;
            obj.sum_eco_jobs_created = stats.sum_eco_jobs_created?.toLocaleString();
            obj.display_policies = stats.display_policies;
            obj.display_technical_planning = stats.display_technical_planning;
            obj.display_financial_flows = stats.display_financial_flows
            obj.display_monitoring_systems = stats.display_monitoring_systems;
            obj.display_area_of_land = stats.display_area_of_land;
            obj.display_climate = stats.display_climate;
            obj.display_biodiversity = stats.display_biodiversity;
            obj.display_economy = stats.display_economy;
            obj.reportid = reportLocation.reportid;

            setDataState(obj);
        } else {
            const obj: any = { ...dataState };
            obj["selectedLocation"] = '';
            setDataState(obj);
        }

        Utils.setStateValue("loading", false, state, setState);
        if (reportLocation)
            getActivitiesAndGADM(reportLocation);
    }

    const findReport = async (gid: string, year: string): Promise<IReportLocation | undefined> => {

        const where = `${reportMainConfig.fields.repYear} = '${year}' and (${reportMainConfig.fields.gid0} = '${gid}' or ${reportMainConfig.fields.gid1} = '${gid}') and ${reportMainConfig.fields.published} = 1`;
        const queryFields: string[] = [reportMainConfig.fields.objectid, reportMainConfig.fields.reportID, reportMainConfig.fields.gid0, reportMainConfig.fields.gid1, reportMainConfig.fields.name0, reportMainConfig.fields.name1, reportMainConfig.fields.repYear, reportMainConfig.fields.haPledged, reportMainConfig.fields.pledgeStart, reportMainConfig.fields.baselineYear];
        const features: IFeature[] = await QueryService.queryFeatures(Utils.getReportLayerQuery(reportMainConfig.index), where, false, queryFields, `${reportMainConfig.fields.name0} ASC, ${reportMainConfig.fields.name1} ASC, ${reportMainConfig.fields.repYear} ASC`, null, false);

        const feature: IFeature | undefined = features[0];

        if (!feature)
            return undefined;

        let report: IReportLocation = {
            title: "",
            objectid: feature.attributes[reportMainConfig.fields.objectid],
            reportid: feature.attributes[reportMainConfig.fields.reportID],
            gid: feature.attributes[reportMainConfig.fields.gid1] ? feature.attributes[reportMainConfig.fields.gid1] : feature.attributes[reportMainConfig.fields.gid0],
            GID_0: feature.attributes[reportMainConfig.fields.gid0],
            NAME_0: feature.attributes[reportMainConfig.fields.name0],
            GID_1: feature.attributes[reportMainConfig.fields.gid1],
            NAME_1: feature.attributes[reportMainConfig.fields.name1],
            years: [],
            ha_pledged: feature.attributes[reportMainConfig.fields.haPledged],
            pledge_start: feature.attributes[reportMainConfig.fields.pledgeStart],
            baseline_year: feature.attributes[reportMainConfig.fields.baselineYear]
        };

        if (report.GID_1) {
            report.gid = report.GID_1;
            report.title = report.NAME_1;
            return report;
        }
        else if (report.GID_0) {
            report.gid = report.GID_0;
            report.title = report.NAME_0;
            return report;
        }

        return report;
    }

    const fetchStatisticsData = async (reportFeature: IReportLocation, year: string, gid0: string): Promise<any> => {

        const relatedFeaturesRB = await getRelatedFeatures(Utils.getReportLayerQuery(reportMainConfig.index), reportMainConfig.relationships.reportRb, [reportFeature.objectid], '*');
        const relatedFeaturesPolicies = await getRelatedFeatures(Utils.getReportLayerQuery(reportMainConfig.index), reportMainConfig.relationships.reportPolicies, [reportFeature.objectid])
        const relatedFeaturesTechnicalPlanning = await getRelatedFeatures(Utils.getReportLayerQuery(reportMainConfig.index), reportMainConfig.relationships.reportTechnicalPlanning, [reportFeature.objectid]);
        const relatedFeaturesFinancialFlows = await getRelatedFeatures(Utils.getReportLayerQuery(reportMainConfig.index), reportMainConfig.relationships.reportFinancialFlows, [reportFeature.objectid]);
        const relatedFeaturesMonitoringSystems = await getRelatedFeatures(Utils.getReportLayerQuery(reportMainConfig.index), reportMainConfig.relationships.reportMonitoring, [reportFeature.objectid]);
        const refInterventionTypesFeatures = await QueryService.queryFeatures(Utils.getReferenceTableQuery(refTablesConfig.REF_INTERVENTION_TYPE.index), '1 = 1', false, "*", '', null, false);
        const refC02EstimationSystemFeatures = await QueryService.queryFeatures(Utils.getReferenceTableQuery(refTablesConfig.REF_CO2_ESTIMATION_SYSTEM.index), '1 = 1', false, "*", '', null, false);
        const refFinancialFlowsTypeFeatures = await QueryService.queryFeatures(Utils.getReferenceTableQuery(refTablesConfig.REF_FINANCIALFLOWS_TYPE.index), '1 = 1', false, "*", '', null, false);
        const refJobsTypeFeatures = await QueryService.queryFeatures(Utils.getReferenceTableQuery(refTablesConfig.REF_JOB_TYPE.index), '1 = 1', false, "*", '', null, false);
        const refMonitApproachScaleFeatures = await QueryService.queryFeatures(Utils.getReferenceTableQuery(refTablesConfig.REF_MONITORING_APPROACH_SCALE.index), '1 = 1', false, "*", '', null, false);
        const refMonitTrackedElemFeatures = await QueryService.queryFeatures(Utils.getReferenceTableQuery(refTablesConfig.REF_MONITORING_TRACKED_ELEMENTS.index), '1 = 1', false, "*", '', null, false);
        const refMeasureUnitFeatures = await QueryService.queryFeatures(Utils.getReferenceTableQuery(refTablesConfig.REF_JOB_MEASURE_UNIT.index), '1 = 1', false, "*", '', null, false);
        const planningStatusFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_PLANNING_STATUS.index);

        const sum_ha_under_resto = relatedFeaturesRB?.reduce(function (prev: number, current: IFeature) {

            //return prev + current.attributes[reportRBConfig.fields.ha_under_resto]
            if (current.attributes[reportRBConfig.fields.ha_under_resto] != undefined) {
                return prev + current.attributes[reportRBConfig.fields.ha_under_resto]
            }
            else {
                return prev;
            }
        }, 0);



        const sum_co2_sequestered = relatedFeaturesRB?.reduce(function (prev: number, current: IFeature) {
            return prev + current.attributes[reportRBConfig.fields.co2_sequestered]
        }, 0);

        const sum_invested: number = relatedFeaturesFinancialFlows?.reduce(function (prev: number, current: IFeature) {
            return prev + current.attributes[reportFinancialFlowsConfig.fields.amount]
        }, 0);

        const sum_eco_jobs_created = relatedFeaturesRB?.reduce(function (prev: number, current: IFeature) {
            return prev + current.attributes[reportRBConfig.fields.eco_jobs_created]
        }, 0);

        let displayPolicies = false;
        let displayFinancialFlows = false;
        let displayTechnicalPlanning = false;
        let displayMonitoringSystems = false;
        let displayAreaOfLand = false;
        let displayClimate = false;
        let displayBiodiversity = false;
        let displayEconomy = false;
        let reportId = "";
        let report = [];
        let country = [];
        let state = [];
        const obj: any = { ...sectionData };
        obj.policies.chartConfig.data.labels = [];
        (obj.policies.chartConfig.data.datasets[0] as any).data = []
        obj.policies.chartConfigSecond.data.labels = [];
        (obj.policies.chartConfigSecond.data.datasets[0] as any).data = []
        obj.financialFlows.chartConfig.data.labels = [];
        obj.financialFlows.chartConfig.data.datasets = [];
        obj.areaOfLand.pieChartConfig.data.labels = [];
        (obj.areaOfLand.pieChartConfig.data.datasets[0] as any).data = []
        obj.economy.pieChartConfig1.data.labels = [];
        (obj.economy.pieChartConfig1.data.datasets[0] as any).data = [];
        obj.economy.pieChartConfig2.data.labels = [];
        (obj.economy.pieChartConfig2.data.datasets[0] as any).data = [];
        obj.economy.chartConfig.data.labels = [];
        obj.economy.chartConfig.data.datasets = [];
        obj.biodiversity.chartConfigBiodiversity.data.labels = [];

        const where = `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear} = '${year}' and (${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.gid0} = '${gid0}' or ${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.gid1} = '${gid0}') and published = 1`;

        let reportFeatures = await QueryService.queryFeatures(Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), where, false, '*', `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear} DESC`, null, false);
        const objectIdsReports: number[] = reportFeatures.map((feat: IFeature) => { return feat.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.objectid] });

        const reports: IReport[] = reportFeatures.map((feat: IFeature) => {

            const id: number = Number(feat.attributes[reportMainConfig.fields.objectid]);
            const year: number = Number(feat.attributes[reportMainConfig.fields.repYear]);
            const gid0: String = String(feat.attributes[reportMainConfig.fields.gid0]);
            const gid1: String = String(feat.attributes[reportMainConfig.fields.gid1]);
            const name0: string = feat.attributes[reportMainConfig.fields.name0];
            const name1: string = feat.attributes[reportMainConfig.fields.name1];
            const published: boolean = feat.attributes[reportMainConfig.fields.published];
            const submitted: boolean = feat.attributes[reportMainConfig.fields.submitted];

            const zone: string = name1 ? `${name1} (State)` : `${name0} (Country)`;
            const status: any = published && submitted ? 'Published' : !published && submitted ? 'Submitted' : 'Saved';
            let attr: any = {};
            for (const key in feat.attributes)
                attr[key] = feat.attributes[key];
            attr.gid0 = gid0;
            attr.gid1 = gid1;
            attr.name0 = name0;
            attr.name1 = name1;
            attr.year = year;
            attr.zone = zone;
            attr.clickable = false;
            if (feat.attributes[reportMainConfig.fields.gid1]) {
                attr.clickable = true;
            } else if (feat.attributes[reportMainConfig.fields.gid0]) {
                attr.clickable = true;
            }

            return attr;
        });

        obj.reports = reports;

        const distinctGID1: Array<String> = reports.map((report: any) => report.gid1).filter((value, index, self) => self.indexOf(value) === index);
        const distinctGID0: any = reports.filter((report: any) => (report.gid1 == 'null' || report.gid1 == '')).map((report: any) => report.gid0);
        let countries: IFeature[] = [];
        let states: IFeature[] = [];

        if (reportFeatures[0].attributes['GID_0'] != null) {
            countries = await QueryService.queryFeatures(Utils.getGADMLayerQuery(gadm0Config.index), gadm0Config.fields.gid0 + " IN ('" + distinctGID0.join("','") + "')", true, '*', '', null, false);

            //fill countries features with related features
            countries = countries.map((country: IFeature) => {
                const report: any | undefined = reports.find((item: any) => item.gid0 == country.attributes[gadm0Config.fields.gid0]);
                if (report)
                    for (const key in report)
                        if (key != "OBJECTID")
                            country.attributes[key] = report[key];
                return country;
            });
        }

        if (reportFeatures[0].attributes['GID_1'] != null) {
            states = await QueryService.queryFeatures(Utils.getGADMLayerQuery(gadm1Config.index), gadm1Config.fields.gid1 + " IN ('" + distinctGID1.join("','") + "')", true, '*', '', null, false);
            states = states.map((state: IFeature) => {
                const report: any | undefined = reports.find((item: any) => item.gid1 == state.attributes[gadm1Config.fields.gid1]);
                if (report)
                    for (const key in report)
                        if (key != "OBJECTID")
                            state.attributes[key] = report[key];
                return state;
            });
        }

        setDataState({
            reports: reports,
            countries: countries,
            states: states,
            selectedGid: "",
            selectedLocation: "",
            selectedYear: "",
            ha_pledged: 0,
            pledge_year: 0,
            baseline_year: 0,
            sum_ha_under_resto: 0,
            sum_co2_sequestered: 0,
            sum_invested: 0,
            sum_eco_jobs_created: 0,
            display_policies: false,
            display_technical_planning: false,
            display_financial_flows: false,
            display_monitoring_systems: false,
            display_area_of_land: false,
            display_climate: false,
            display_biodiversity: false,
            display_economy: false,
            reportid: ""
        });

        obj.country = countries;
        obj.state = states;

        setSectionData(obj);

        let colors: any[] = ['rgb(87, 204, 171)', 'rgb(18, 64, 64)', 'rgb(0, 20, 64)', 'rgb(255, 84, 0)', 'rgb(255, 247, 0)', 'rgb(247, 140, 199)', 'rgb(229, 229, 229)', 'rgb(69, 71, 77)']

        if (relatedFeaturesPolicies) {
            const relatedPolicies = relatedFeaturesPolicies.map((feat: IFeature) => feat.attributes);
            const policiesGroupByYear = DashboardUtils.groupBy(relatedPolicies, reportPoliciesConfig.fields.yearEnacted);
            const policiesGroupByResponsible = DashboardUtils.groupBy(relatedPolicies, reportPoliciesConfig.fields.responsible);

            obj.policies.chartConfig.data.labels = DashboardUtils.createChartLabels(policiesGroupByYear);
            let total = 0;
            (obj.policies.chartConfig.data.datasets[0] as any).data = Object.keys(policiesGroupByYear).map((year: string) => { total += policiesGroupByYear[Number(year)].length; return policiesGroupByYear[Number(year)].length });
            (obj.policies.chartConfig.data.datasets[0] as any).data.total = total;
            obj.policies.chartConfigSecond.data.labels = DashboardUtils.createChartLabels(policiesGroupByResponsible);
            (obj.policies.chartConfigSecond.data.datasets[0] as any).data = Object.keys(policiesGroupByResponsible).map((responsible: string) => policiesGroupByResponsible[responsible].length);
            (obj.policies.chartConfigSecond.data.datasets[0] as any).backgroundColor = colors[0];
            (obj.policies.chartConfigSecond.data.datasets[0] as any).borderColor = colors[0];
            obj.policies.attributes = relatedPolicies.sort((item1, item2) => item1[reportPoliciesConfig.fields.yearEnacted] > item2[reportPoliciesConfig.fields.yearEnacted] ? 1 : -1);
            displayPolicies = true;
        }

        if (relatedFeaturesTechnicalPlanning) {
            const relatedTechnicalPlannings = relatedFeaturesTechnicalPlanning.map((feat: IFeature) => feat.attributes);
            obj.technicalPlanning.attributes = relatedTechnicalPlannings;

            const landScape_status_values = planningStatusFeatures.map((feat: IFeature) => feat.attributes);
            if (relatedFeaturesTechnicalPlanning.length > 0) {
                const landScapeValuesArr: string[] = [];
                const scapValArr: string[] = [];
                relatedFeaturesTechnicalPlanning.forEach((status) => {
                    let statusatt = status.attributes.landscape_status;
                    if (statusatt != null && statusatt.indexOf(',') > -1) {
                        const statusattArr: string[] = statusatt ? statusatt.split(',') : [];
                        statusattArr.forEach((el) => {
                            const typeFeature = planningStatusFeatures.find((financialTypeFeature: IFeature) =>
                                financialTypeFeature.attributes.key_ == el);
                            if (typeFeature) {
                                let valueData = typeFeature.attributes.value;
                                scapValArr.push(' ' + valueData);
                            }
                        });
                        landScapeValuesArr.push(scapValArr.toString());
                    }
                    else {
                        const typeFeature = planningStatusFeatures.find((financialTypeFeature: IFeature) =>
                            financialTypeFeature.attributes.key_ == statusatt);
                        if (typeFeature) {
                            let valueData = typeFeature.attributes.value;
                            landScapeValuesArr.push(valueData);
                        }
                    }
                });
                obj.technicalPlanning.refattributes = landScapeValuesArr;
                displayTechnicalPlanning = true;
            }

        }

        if (relatedFeaturesFinancialFlows) {
            const relatedFinancialFlows = relatedFeaturesFinancialFlows.map((feat: IFeature) => {
                let attributes = feat.attributes;
                const typeFeature = refFinancialFlowsTypeFeatures.find((financialTypeFeature: IFeature) => financialTypeFeature.attributes[refTablesConfig.REF_FINANCIALFLOWS_TYPE.fields.key] == feat.attributes[reportFinancialFlowsConfig.fields.type]);
                attributes[reportFinancialFlowsConfig.fields.type] = typeFeature ? typeFeature.attributes[refTablesConfig.REF_FINANCIALFLOWS_TYPE.fields.value] : attributes[reportFinancialFlowsConfig.fields.type];
                return attributes;
            });
            const financialFlowsGroupByType = DashboardUtils.groupBy(relatedFinancialFlows, reportFinancialFlowsConfig.fields.type);
            const distinctFinancialTiers: string[] = relatedFeaturesFinancialFlows.map((feat: IFeature) => feat.attributes[reportFinancialFlowsConfig.fields.tier]).filter((value, index, self) => (value != null && self.indexOf(value) === index) && value != null);
            let total = 0;
            displayFinancialFlows = true;

            obj.financialFlows.chartConfig.data.labels = DashboardUtils.createChartLabels(financialFlowsGroupByType);
            const datasets: any[] = distinctFinancialTiers.map((tier: string, index: number) => {
                let dataset: any = {};
                dataset.label = "Tier " + tier;
                dataset.backgroundColor = colors[index];
                dataset.stack = 'Stack 1';
                dataset.data = Object.keys(financialFlowsGroupByType).map((type: string, index: number) => {
                    const amount = relatedFeaturesFinancialFlows.filter((feat: IFeature) => feat.attributes[reportFinancialFlowsConfig.fields.type] == type)
                        .reduce(function (prev: number, current: IFeature) {
                            return prev + current.attributes[reportFinancialFlowsConfig.fields.amount];
                        }, 0);
                    total += amount;
                    return amount;
                });
                return dataset;
            });
            obj.financialFlows.chartConfig.data.datasets = datasets;
            (obj.financialFlows.chartConfig.data.datasets[0] as any).data.total = total;
            obj.financialFlows.attributes = relatedFinancialFlows.sort((item1, item2) => item1[reportFinancialFlowsConfig.fields.tier] > item2[reportFinancialFlowsConfig.fields.tier] ? 1 : -1);

            displayFinancialFlows = true;
        }

        if (relatedFeaturesMonitoringSystems) {
            //Geo scales and tracked list values instead of keys
            const relatedMonitoringSystems = relatedFeaturesMonitoringSystems.map((feat: IFeature) => {
                const geoScaleIds: string = feat.attributes[reportMonitoringConfig.fields.geo_scale];
                const geoScaleIdsArr: string[] = geoScaleIds ? geoScaleIds.split(',') : [];
                const geoScaleValuesArr: string[] = [];

                const trackListIds: string = feat.attributes[reportMonitoringConfig.fields.track_list];
                const trackListIdsArr: string[] = trackListIds ? trackListIds.split(',') : [];
                const trackListValuesArr: string[] = [];

                // Geo scale
                geoScaleIdsArr.forEach((id: string) => {
                    const geoScaleFeature = refMonitApproachScaleFeatures.find((geoScaleFeature: IFeature) => Number(geoScaleFeature.attributes[refTablesConfig.REF_MONITORING_APPROACH_SCALE.fields.key]) === Number(id));
                    if (geoScaleFeature) {
                        geoScaleValuesArr.push(geoScaleFeature.attributes[refTablesConfig.REF_MONITORING_APPROACH_SCALE.fields.value]);
                    }
                });

                // Track list
                trackListIdsArr.forEach((id: string) => {
                    const trackListFeature = refMonitTrackedElemFeatures.find((trackListFeature: IFeature) => Number(trackListFeature.attributes[refTablesConfig.REF_MONITORING_TRACKED_ELEMENTS.fields.key]) === Number(id));
                    if (trackListFeature) {
                        let value = trackListFeature.attributes[refTablesConfig.REF_MONITORING_TRACKED_ELEMENTS.fields.value];

                        if (trackListFeature.attributes[refTablesConfig.REF_MONITORING_TRACKED_ELEMENTS.fields.key] === ConfigService.getConfig().agol.referenceTables.otherKeyValue) {
                            value = '';
                        }

                        trackListValuesArr.push(value);
                    }
                });

                feat.attributes[reportMonitoringConfig.fields.geo_scale] = geoScaleValuesArr.join('\\n');
                feat.attributes[reportMonitoringConfig.fields.track_list] = trackListValuesArr.join('\\n');

                return feat.attributes;
            });;
            obj.monitoringSystems.attributes = relatedMonitoringSystems;

            if (relatedMonitoringSystems.length > 0) {
                displayMonitoringSystems = true;
            }
        }

        if (relatedFeaturesRB) {

            const co2Systems: any = {};

            // Related RB
            const relatedRB = relatedFeaturesRB.map((feat: IFeature) => {
                const attributes = feat.attributes;

                // Intervention types
                const interventionTypesIds: string = attributes[reportRBConfig.fields.ha_intervention_types];
                const interventionTypesIdsArr: string[] = interventionTypesIds ? interventionTypesIds.split(',') : [];

                if (interventionTypesIdsArr.length) {
                    attributes.ha_intervention_types_values = refInterventionTypesFeatures
                        .filter((interventonTypeFeature: IFeature) => interventionTypesIds.indexOf(`${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.key]}`) != -1)
                        .map((interventonTypeFeature: IFeature) => `${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.ecosystem]} - ${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.value]}`);
                }
                if (interventionTypesIdsArr.length) {
                    const keyEcosystemInterventionType = refInterventionTypesFeatures
                        .filter((interventonTypeFeature: IFeature) => interventionTypesIds.indexOf(`${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.key]}`) != -1)
                        .map((interventonTypeFeature: IFeature) => `${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.ecosystem]}`).filter((value, index, self) => (value != null && self.indexOf(value) === index));

                    const keyIntervention = refInterventionTypesFeatures
                        .filter((interventonTypeFeature: IFeature) => interventionTypesIds.indexOf(`${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.key]}`) != -1)
                        .map((interventonTypeFeature: IFeature) => `${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.value]}`).filter((value, index, self) => (value != null && self.indexOf(value) === index));

                    const AreaLandInterventionType = refInterventionTypesFeatures
                        .filter((interventonTypeFeature: IFeature) => interventionTypesIds.indexOf(`${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.key]}`) != -1)
                        .map((interventonTypeFeature: IFeature) => `${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.ecosystem]}`).filter((value, index, self) => (value != null && self.indexOf(value) === index));

                    const keyEcosystemInterventionTypes = refInterventionTypesFeatures
                        .filter((interventonTypeFeature: IFeature) => interventionTypesIds.indexOf(`${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.key]}`) != -1)
                        .map((interventonTypeFeature: IFeature) => `${interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.value]}`);

                    attributes.ha_intervention_types_values = AreaLandInterventionType;
                    attributes.ha_information = keyEcosystemInterventionTypes;
                    obj.keyEcosystem.attributes = keyEcosystemInterventionType;
                    obj.keyIntervention.attributes = keyIntervention;
                }

                // C02 Estimation System
                const co2SystemsIds: string = attributes[reportRBConfig.fields.co2_systems];
                const co2SystemsIdsArr: string[] = co2SystemsIds ? co2SystemsIds.split(',') : [];

                if (co2SystemsIdsArr.length) {
                    co2SystemsIdsArr.forEach((id: string) => {
                        //const value: string = refC02EstimationSystemFeatures
                        const co2SystemFeature = refC02EstimationSystemFeatures.find((co2SystempeFeature: IFeature) => Number(co2SystempeFeature.attributes[refTablesConfig.REF_CO2_ESTIMATION_SYSTEM.fields.key]) === Number(id));
                        if (co2SystemFeature) {
                            const value: string = co2SystemFeature.attributes[refTablesConfig.REF_CO2_ESTIMATION_SYSTEM.fields.value];

                            if (!co2Systems[value]) {
                                co2Systems[value] = 0;
                            }

                            co2Systems[value] = co2Systems[value] + 1;
                        }
                    });
                }

                return attributes;
            });

            obj.relatedRB = relatedRB;
            const arr: any[] = [];
            Object.keys(co2Systems).forEach((key: string) => {
                arr.push({ id: key, count: co2Systems[key] });
            });

            obj.c02EstimationSystems = arr.sort((a: { id: string, count: number }, b: { id: string, count: number }) => a.count < b.count ? 1 : -1).map((a: { id: string, count: number }) => `${a.id} : ${a.count}`);

            const rbGroupByInterventionType = DashboardUtils.groupBy(relatedRB, reportRBConfig.fields.ha_intervention_types);
            const reportRbObjectIds = relatedRB.map((item: any) => item[reportRBConfig.fields.objectid]);

            let relatedFeaturesRBJobs = await getRelatedFeatures(Utils.getReportLayerQuery(reportRBConfig.index), reportMainConfig.relationships.reportRbJobs, reportRbObjectIds)
            let rbJobsGroupByType: any = {};
            let relatedRbJobs: any[] = [];

            if (relatedFeaturesRBJobs) {
                relatedFeaturesRBJobs = relatedFeaturesRBJobs?.map((feat: IFeature) => {
                    const featRB: IFeature | undefined = relatedFeaturesRB.find((featRB: IFeature) => featRB.attributes[reportRBConfig.fields.globalid] == feat.attributes[reportRbJobsConfig.fields.report_rb_id]);
                    feat.attributes[reportRBConfig.fields.name_0] = featRB?.attributes[reportRBConfig.fields.name_0];
                    feat.attributes[reportRBConfig.fields.name_1] = featRB?.attributes[reportRBConfig.fields.name_1];
                    feat.attributes[reportRBConfig.fields.name_2] = featRB?.attributes[reportRBConfig.fields.name_2];
                    return feat;
                })

                relatedRbJobs = relatedFeaturesRBJobs.map((feat: IFeature) => {
                    let attributes = feat.attributes;
                    const ecoTypeFeature = refJobsTypeFeatures.find((ecoTypeFeature: IFeature) => ecoTypeFeature.attributes[refTablesConfig.REF_JOB_TYPE.fields.key] == feat.attributes[reportRbJobsConfig.fields.ecoType]);
                    attributes[reportRbJobsConfig.fields.ecoType] = ecoTypeFeature ? ecoTypeFeature.attributes[refTablesConfig.REF_JOB_TYPE.fields.value] : attributes[reportRbJobsConfig.fields.ecoType];
                    return attributes;
                });

                rbJobsGroupByType = DashboardUtils.groupBy(relatedRbJobs, reportRbJobsConfig.fields.ecoType);
            }

            obj.areaOfLand.pieChartConfig.data.labels = DashboardUtils.createChartLabels(rbGroupByInterventionType);
            (obj.areaOfLand.pieChartConfig.data.datasets[0] as any).data = Object.keys(rbGroupByInterventionType).map((interventionType: string) => {
                const sum = rbGroupByInterventionType[interventionType].reduce((prev: number, current: any) => {
                    return prev + current[reportRBConfig.fields.ha_under_resto]
                }, 0);
                return sum;
            });
            (obj.areaOfLand.pieChartConfig.data.datasets[0] as any).backgroundColor = colors.slice(0, rbGroupByInterventionType.length);
            (obj.areaOfLand.pieChartConfig.data.datasets[0] as any).borderColor = colors.slice(0, rbGroupByInterventionType.length);

            // Intervention types values instead of keys
            obj.areaOfLand.attributes = relatedRB.sort((item1, item2) => item1[reportRBConfig.fields.ha_tier] > item2[reportRBConfig.fields.ha_tier] ? 1 : -1);
            obj.areaOfLand.attributes = obj.areaOfLand.attributes.map((att: any) => {
                const interventionTypesIds: string = att[reportRBConfig.fields.ha_intervention_types];
                const interventionTypesIdsArr: string[] = interventionTypesIds ? interventionTypesIds.split(',') : [];
                const interventionTypesValuesArr: string[] = [];

                interventionTypesIdsArr.forEach((id: string) => {
                    const interventonTypeFeature = refInterventionTypesFeatures.find((interventonTypeFeature: IFeature) => interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.key] === Number(id));
                    if (interventonTypeFeature) {
                        interventionTypesValuesArr.push(interventonTypeFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.value]);
                    }
                });

                att[reportRBConfig.fields.ha_intervention_types] = interventionTypesValuesArr.join('\\n');
                return att;
            });

            displayAreaOfLand = true;

            // CO2 systems values instead of keys
            const relatedClimate = relatedFeaturesRB.map((feat: IFeature) => {
                const co2SystemsIds: string = feat.attributes[reportRBConfig.fields.co2_systems];
                const co2SystemsIdsArr: string[] = co2SystemsIds ? co2SystemsIds.split(',') : [];
                const co2SystemsValuesArr: string[] = [];

                co2SystemsIdsArr.forEach((id: string) => {
                    const co2SystemFeature = refC02EstimationSystemFeatures.find((co2SystempeFeature: IFeature) => Number(co2SystempeFeature.attributes[refTablesConfig.REF_CO2_ESTIMATION_SYSTEM.fields.key]) === Number(id));
                    if (co2SystemFeature) {
                        co2SystemsValuesArr.push(co2SystemFeature.attributes[refTablesConfig.REF_CO2_ESTIMATION_SYSTEM.fields.value]);
                    }
                });

                feat.attributes[reportRBConfig.fields.co2_systems] = co2SystemsValuesArr.join('\\n');
                return feat.attributes;
            });

            obj.climate.attributes = relatedClimate;

            if (relatedClimate.length > 0)
                displayClimate = true;

            obj.biodiversity.pieChartConfig.data.labels = config.detail.biodiversityAreaType.map((item: FieldInfo) => item.label);
            obj.biodiversity.chartConfigBiodiversity.data.labels = config.detail.biodiversityAreaType.map((item: FieldInfo) => item.label);
            (obj.biodiversity.pieChartConfig.data.datasets[0] as any).data = config.detail.biodiversityAreaType.map((item: FieldInfo) => {
                const sum = relatedRB.reduce((prev: number, current: any) => {
                    return prev + current[item.fieldName]
                }, 0);
                return sum;
            });
            (obj.biodiversity.chartConfigBiodiversity.data.datasets[0] as any).data = config.detail.biodiversityAreaType.map((item: FieldInfo) => {
                const sum = relatedRB.reduce((prev: number, current: any) => {
                    return prev + current[item.fieldName]
                }, 0);
                return sum;
            });
            (obj.biodiversity.pieChartConfig.data.datasets[0] as any).backgroundColor = colors.slice(0, config.detail.biodiversityAreaType.length);
            (obj.biodiversity.pieChartConfig.data.datasets[0] as any).borderColor = colors.slice(0, config.detail.biodiversityAreaType.length);
            (obj.biodiversity.chartConfigBiodiversity.data.datasets[0] as any).backgroundColor = colors[0];
            (obj.biodiversity.chartConfigBiodiversity.data.datasets[0] as any).borderColor = colors[0];
            (obj.biodiversity.chartConfigBiodiversity.data.datasets[0] as any).label = "red";
            obj.biodiversity.attributes = relatedRB;
            displayBiodiversity = true;

            //Economy : pie chart "Jobs created by type"
            if (Object.keys(rbJobsGroupByType).length > 0) {
                obj.economy.pieChartConfig1.data.labels = DashboardUtils.createChartLabels(rbJobsGroupByType);
                (obj.economy.pieChartConfig1.data.datasets[0] as any).data = Object.keys(rbJobsGroupByType).map((ecoType: string) => {
                    const sum = rbJobsGroupByType[ecoType].reduce((prev: number, current: any) => {
                        return prev + current[reportRbJobsConfig.fields.eco_jobs]
                    }, 0);
                    return sum;
                });
                (obj.economy.pieChartConfig1.data.datasets[0] as any).backgroundColor = colors.slice(0, rbJobsGroupByType.length);
                (obj.economy.pieChartConfig1.data.datasets[0] as any).borderColor = colors.slice(0, rbJobsGroupByType.length);
                //Economy : pie chart "Jobs created by gender"
                obj.economy.pieChartConfig2.data.labels = config.detail.economyGenders.map((item: FieldInfo) => item.label);
                (obj.economy.pieChartConfig2.data.datasets[0] as any).data = config.detail.economyGenders.map((item: FieldInfo) => {
                    const sum = relatedRbJobs.reduce((prev: number, current: any) => {
                        return prev + current[item.fieldName]
                    }, 0);
                    return sum;
                });
                (obj.economy.pieChartConfig2.data.datasets[0] as any).backgroundColor = colors.slice(0, config.detail.economyGenders.length);
                (obj.economy.pieChartConfig2.data.datasets[0] as any).borderColor = colors.slice(0, config.detail.economyGenders.length);

                //Economy : stack bar "Jobs created by type and by gender"
                obj.economy.chartConfig.data.labels = DashboardUtils.createChartLabels(rbJobsGroupByType);
                const datasets: any[] = config.detail.economyGenders.map((item: FieldInfo, index: number) => {
                    let dataset: any = {};
                    dataset.label = item.label;
                    dataset.backgroundColor = colors[index];
                    dataset.stack = 'Stack 1';
                    dataset.data = Object.keys(rbJobsGroupByType).map((type: string, index: number) => {
                        const amount = relatedFeaturesRBJobs.filter((feat: IFeature) => feat.attributes[reportRbJobsConfig.fields.ecoType] == type)
                            .reduce(function (prev: number, current: IFeature) {
                                return prev + current.attributes[item.fieldName];
                            }, 0);
                        return amount;
                    });
                    return dataset;
                });
                obj.economy.chartConfig.data.datasets = datasets;

                obj.economy.attributes = relatedRbJobs;

                obj.economy.attributes = obj.economy.attributes.map((att: any) => {
                    const measureUnitsIds: string = att[reportRbJobsConfig.fields.eco_unit];
                    const measureUnitsArr: string[] = measureUnitsIds ? measureUnitsIds.split(',') : [];
                    const measureUnitsValuesArr: string[] = [];

                    measureUnitsArr.forEach((id: string) => {
                        const measureUnitFeature = refMeasureUnitFeatures.find((measureUnitFeature: IFeature) => Number(measureUnitFeature.attributes[refTablesConfig.REF_INTERVENTION_TYPE.fields.key]) === Number(id));

                        if (measureUnitFeature) {
                            measureUnitsValuesArr.push(measureUnitFeature.attributes[refTablesConfig.REF_JOB_MEASURE_UNIT.fields.value]);
                        }
                    });

                    att[reportRbJobsConfig.fields.eco_unit] = measureUnitsValuesArr.join('\\n');
                    return att;
                });

                displayEconomy = true;
            }
        }

        setSectionData(obj);

        return Promise.resolve({
            "reports": reports,
            "countries": countries,
            "states": states,
            "sum_ha_under_resto": sum_ha_under_resto,
            "sum_co2_sequestered": sum_co2_sequestered,
            "sum_invested": sum_invested,
            "sum_eco_jobs_created": sum_eco_jobs_created,
            "display_policies": displayPolicies,
            "display_technical_planning": displayTechnicalPlanning,
            "display_financial_flows": displayFinancialFlows,
            "display_monitoring_systems": displayMonitoringSystems,
            "display_area_of_land": displayAreaOfLand,
            "display_climate": displayClimate,
            "display_biodiversity": displayBiodiversity,
            "display_economy": displayEconomy,
            "reportid": reportId
        });
    }

    const getRelatedFeatures = async (url: string, relationshipId: number, objectIds: number[], outFields: '*' | string[] | undefined = '*'): Promise<IFeature[]> => {

        try {
            if (objectIds && objectIds.length > 0) {
                const relatedRecords: IRelatedRecordGroup[] = await QueryService.queryRelatedFeatures(url, relationshipId, objectIds, false, outFields, '', false);

                if (relatedRecords && relatedRecords.length > 0) {

                    const relatedRecord: IRelatedRecordGroup | undefined = relatedRecords.find((item: IRelatedRecordGroup) => objectIds.indexOf(item.objectId) >= 0);
                    if (relatedRecord && relatedRecord.relatedRecords && relatedRecord.relatedRecords.length > 0) {
                        let resultFeatures = relatedRecord.relatedRecords;
                        return resultFeatures;
                    }
                }
            }

            return Promise.resolve(null as any);

        } catch (err: any) {
            console.error(err);
            return Promise.reject(err);
        }
    }

    const fillOptions = async () => {

        const queryFields: string[] = [reportMainConfig.fields.gid0, reportMainConfig.fields.gid1, reportMainConfig.fields.name0, reportMainConfig.fields.name1, reportMainConfig.fields.repYear];
        let locationsFeatures = await QueryService.queryFeatures(Utils.getReportLayerQuery(reportMainConfig.index), 'published = 1', false, queryFields, `${reportMainConfig.fields.name0} ASC, ${reportMainConfig.fields.name1} ASC, ${reportMainConfig.fields.repYear} ASC`, null, false);
        const distinctGID0: string[] = locationsFeatures.map((feat: IFeature) => feat.attributes[reportMainConfig.fields.gid0]).filter((value, index, self) => (value != null && self.indexOf(value) === index));
        const distinctGID1: string[] = locationsFeatures.map((feat: IFeature) => feat.attributes[reportMainConfig.fields.gid1]).filter((value, index, self) => (value != null && self.indexOf(value) === index) && value != null);

        const reportCountries: IReportLocation[] = distinctGID0.map((gid0: string) => {
            //Entité countries (dont gid1 est null)
            const filterFeatures: Array<IFeature> = locationsFeatures.filter((feat: IFeature) => feat.attributes[reportMainConfig.fields.gid0] == gid0)

            let attr: any = {}
            attr.title = filterFeatures[0]?.attributes[reportMainConfig.fields.name0];
            attr.GID_0 = filterFeatures[0]?.attributes[reportMainConfig.fields.gid0];
            attr.NAME_0 = filterFeatures[0]?.attributes[reportMainConfig.fields.name0];
            attr.years = filterFeatures.filter((feat: IFeature) => feat.attributes[reportMainConfig.fields.gid1] == null)?.map((feat: IFeature) => feat.attributes[reportMainConfig.fields.repYear])
            return attr;
        });

        const reportStates: IReportLocation[] = distinctGID1.map((gid1: string) => {
            //Entité countries (dont gid1 est null)
            const filterFeatures: Array<IFeature> = locationsFeatures.filter((feat: IFeature) => feat.attributes[reportMainConfig.fields.gid1] == gid1);

            let attr: any = {}
            attr.title = filterFeatures[0]?.attributes[reportMainConfig.fields.name1];
            attr.GID_0 = filterFeatures[0]?.attributes[reportMainConfig.fields.gid0];
            attr.NAME_0 = filterFeatures[0]?.attributes[reportMainConfig.fields.name0]
            attr.GID_1 = filterFeatures[0]?.attributes[reportMainConfig.fields.gid1];
            attr.NAME_1 = filterFeatures[0]?.attributes[reportMainConfig.fields.name1]
            attr.years = filterFeatures.filter((feat: IFeature) => feat.attributes[reportMainConfig.fields.gid1] != null)?.map((feat: IFeature) => feat.attributes[reportMainConfig.fields.repYear])

            return attr;
        });


        const years: string[] = await getReportYears(props.selectedGID);

        const obj: any = { ...optionsState };
        obj["listReportCountries"] = reportCountries;
        obj["listReportStates"] = reportStates;
        obj["years"] = years;
        setOptionsState(obj);

    }

    const getReportYears = async (gid: string) => {

        const where = `${reportMainConfig.fields.published} = 1 and (${reportMainConfig.fields.gid0} = '${gid}' or ${reportMainConfig.fields.gid1} = '${gid}')`
        const queryFields: string[] = [reportMainConfig.fields.repYear];
        let features = await QueryService.queryFeatures(Utils.getReportLayerQuery(reportMainConfig.index), where, false, queryFields, `${reportMainConfig.fields.name0} ASC, ${reportMainConfig.fields.name1} ASC, ${reportMainConfig.fields.repYear} ASC`, null, false);
        const distinctYears: string[] = features.map((feat: IFeature) => feat.attributes[reportMainConfig.fields.repYear]).filter((value, index, self) => (value != null && self.indexOf(value) === index));

        return distinctYears;
    }

    const onSelectLocation = async (gid: string) => {
        if (dataState.selectedGid !== gid) {
            state.activitiesPointFeatures = [];
            state.activitiesPolygonFeatures = [];
        }
        const years = await getReportYears(gid);
        const obj: any = { ...optionsState };
        obj["years"] = years;
        setOptionsState(obj);

        fetchData(gid, years[years.length - 1]);
    }

    const onSelectYear = async (gid: string, year: string) => {
        if (dataState.selectedYear !== year) {
            state.activitiesPointFeatures = [];
            state.activitiesPolygonFeatures = [];
        }
        fetchData(gid, year);

    }

    const onExport = async () => {
        // Open all details before print
        await setFullDataVisibility(true);

        window.print();

        // Close all details after print
        await setFullDataVisibility(false);
    }

    const showCurrentTab = async (sectionTab: any, id: any) => {

        // // Accordions
        const tabLinks = document.querySelectorAll('.tab-content-link');
        const tabContents = document.querySelectorAll('.tab-content');
        if (tabLinks.length > 0 && tabContents.length > 0) {
            tabLinks.forEach(tabLink => {
                tabLink.classList.remove('current');
            });
        }

        const tabId = document.getElementsByClassName(sectionTab)[0];
        tabId.classList.add('current');
    }

    const viewMoreDetails = async (id: any) => {
        const collapsables = document.querySelectorAll('#' + id + '.collapsable');


        collapsables.forEach(collapsable => {
            const collapsableItems = collapsable.querySelectorAll('.collapsabel__item.hidden');
            const viewMoreButton = collapsable.querySelector('.btn-view-more');

            collapsableItems.forEach(el => {
                el.classList.remove('hidden');

            });
            if (viewMoreButton) {
                viewMoreButton.classList.add('hidden');
            }
        });
    }
    const closePopup = async () => {
        const popdiv = document.querySelector('.popover');
        popdiv?.classList.add('hidden');
    }
    const openPolicyTab = async (sectionTab: any, type: any) => {
        const collapsables = document.querySelectorAll('#' + type + '.collapsable');
        let hasHiddenItems = false;
        const secTabItm = collapsables[0].querySelectorAll('.collapsabel__item')[sectionTab];
        if (secTabItm.classList.contains('open')) {
            hasHiddenItems = true;
        }

        const removeItem = collapsables[0].querySelectorAll('.collapsabel__item');
        const rmhightAuto = collapsables[0].querySelectorAll('.collapsabel__item__body.heightAutoAccordion')
        removeItem.forEach(removeItems => {
            const collapsableItemBody = removeItems.querySelector('.collapsabel__item__body');
            if (removeItems.classList.contains('open')) {
                removeItems.classList.remove('open');
                if (collapsableItemBody) {
                    collapsableItemBody.classList.remove('heightAutoAccordion');
                }
                else if (rmhightAuto) {
                    rmhightAuto[0].classList.remove('heightAutoAccordion');
                }
            }
        });

        const colSecTab = collapsables[0].querySelectorAll('.collapsabel__item')[sectionTab];
        const colItem = collapsables[0].querySelectorAll('.collapsabel__item__body')[sectionTab];
        if (hasHiddenItems == true) {
            colSecTab.classList.remove('open');
            colItem.classList.remove('heightAutoAccordion');
        }
        else {

            colSecTab.classList.add('open');
            colItem.classList.add('heightAutoAccordion');
        }
    }

    const openTab = async () => {
        // Section Tabs
        const sectionTabs = document.querySelectorAll('.section-tab .tab__item');
        sectionTabs.forEach(sectionTabItem => {
            const sectionTabItemBody = sectionTabItem.querySelector('.section-tab__body');

            if (sectionTabItemBody) {
                if (sectionTabItem.classList.contains('open')) {
                    sectionTabItem.classList.remove('open');
                    sectionTabItemBody.classList.remove('heightAutoAccordion');
                }
                else {
                    sectionTabItem.classList.add('open');
                    sectionTabItemBody.classList.add('heightAutoAccordion');
                }
            }
        });
    }

    const setFullDataVisibility = async (visible: boolean) => {
        await setPolicyFullDataShow(visible);
        await setFinancialFullDataShow(visible);
        await setTechnicalPlanningFullDataShow(visible);
        await setMonitoringSystemFullDataShow(visible);
        await setAreaOfLandFullDataShow(visible);
        await setClimateFullDataShow(visible);
        await setBiodiversityFullDataShow(visible);
        await setEconomyFullDataShow(visible);
    }

    /**
     * Get info label
     * @param field
     * @param item
     */
    const getInfoLabel = (field: any, item: any): string => {
        let label = item[field.fieldName] || '';

        if (field.fieldLabelFrom) {
            label = (state.referenceLabels as any)[field.fieldLabelFrom][item[field.fieldName]];
        } else if (field.isBoolean) {
            label = label ? 'True' : 'False';
        }

        // Related field
        if (field.relatedFieldName && item[field.relatedFieldName]) {
            label = `${label} - ${item[field.relatedFieldName]}`;
        }

        const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return label !== null && label !== undefined && label !== '' ? label.toString().replace(exp, '<a href="$1" target="_blank">$1</a>') : '-';
    }

    const onSelectedFeature = (countryOrStateName: string) => {
        if (countryOrStateName != null && countryOrStateName != undefined && countryOrStateName != "") {
            openPopup();
        }
        else {
            const popdiv = document.querySelector('.popover');
            popdiv?.classList.add('hidden');
            popdiv?.classList.remove('popoverDisplay');
        }
    }

    const openPopup = async () => {
        const popdiv = document.querySelector('.popover');
        popdiv?.classList.remove('hidden');
        popdiv?.classList.add('popoverDisplay');
    }

    return (
        <>
            <div className="wrapper detaildashboardDiv page-header">
                <div className="row contained">
                    <div className="col-6 options noprint option-selectors">
                        <div className='row'>
                            <div className='col-5'>
                                <div className="title  option-selectors__title">{t('chooseCountry')}</div>
                                {
                                    optionsState.listReportCountries.length > 0 &&
                                    <select className={`mediumText small locationOptions`}
                                        onChange={(e) => { onSelectLocation(e.target.value as string) }} >
                                        {<option value="" key="location_0" disabled selected>{t('selectLocationPlaceHolder')}</option>}
                                        {
                                            optionsState.listReportCountries.map((report: IReportLocation, i: number) => {
                                                return (
                                                    <>
                                                        <option value={report.GID_0} key={report.GID_0} disabled={report.years.length == 0 ? true : false} selected={report.GID_0 == props.selectedGID ? true : false}>{report.NAME_0}</option>
                                                        {
                                                            optionsState.listReportStates.filter((item: IReportLocation) => item.GID_0 == report.GID_0).map((report2: IReportLocation, i: number) => {
                                                                return (<option value={report2.GID_1} key={report2.GID_1} selected={report2.GID_1 == props.selectedGID ? true : false}>&nbsp;&nbsp;&nbsp;{report2.NAME_1}</option>)
                                                            })
                                                        }</>
                                                )
                                            })
                                        }
                                    </select>
                                }
                            </div>
                            <div className='col-4 year-selector'>
                                {
                                    optionsState.years.length > 0 && dataState.selectedGid && dataState.selectedYear &&
                                    <>
                                        <div className="title mediumText">{t('chooseYear')}</div>
                                        <select className={`mediumText small yearOptions`}
                                            onChange={(e) => { onSelectYear(dataState.selectedGid, e.target.value as string) }} >
                                            {<option value="" key="year_0" disabled selected>{t('selectYearPlaceHolder')}</option>}
                                            {
                                                optionsState.years.map((year: number, i: number) => {
                                                    return (
                                                        <option value={year} key={`key_${year}`} selected={year.toString() == dataState.selectedYear ? true : false} >{year}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </>

                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-4 buttons noprint backbtn">
                        <button className="actionBtn primary backbutton" onClick={() => props.onClose()}>
                            <span>{t('close')}</span>
                        </button>
                    </div>
                </div>
                {
                    dataState.selectedLocation &&
                    <>
                        <div className="row veryBigText pageTitle page-title">
                            <span>{dataState.selectedLocation}</span>
                            <ul className="social-icons">
                                <li>
                                    <a href="" className="link-linkedin">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 34">
                                            <g transform="translate(-1042 -425)">
                                                <ellipse cx="17.5" cy="17" rx="17.5" ry="17" transform="translate(1042 425)" fill="#124040" />
                                                <path fill="#fff" d="M1052.978 438.509h2.959v8.927h-2.959z" />
                                                <path d="M1054.456 437.373a1.555 1.555 0 1 1 1.628-1.552 1.591 1.591 0 0 1-1.628 1.552Z" fill="#fff" />
                                                <path d="M1066.474 447.437h-3.042l-.032-5.36s-.034-1.546-1.424-1.5-1.52 1.578-1.52 1.578l.017 5.277h-3.008v-8.927h2.91v1.3s1-2.1 4.011-1.3c0 0 2.055.377 2.089 3.337s-.001 5.595-.001 5.595Z" fill="#fff" />
                                            </g>
                                        </svg>
                                    </a>
                                </li>

                                <li>
                                    <a href="" className="link-facebook">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
                                            <g transform="translate(-1113 -425)">
                                                <circle cx="17" cy="17" r="17" transform="translate(1113 425)" fill="#124040" />
                                                <path d="M1133.691 442.141h-2.206v7.866h-3.268v-7.866h-1.555v-2.778h1.555v-1.8a3.064 3.064 0 0 1 3.3-3.3l2.422.009v2.7h-1.758a.668.668 0 0 0-.694.758v1.633h2.492Z" fill="#fff" />
                                            </g>
                                        </svg>
                                    </a>
                                </li>

                                <li className='liTwitter'>
                                    <a href="" className="link-twitter">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
                                            <g transform="translate(-1183 -425)">
                                                <circle cx="17" cy="17" r="17" transform="translate(1183 425)" fill="#124040" />
                                                <path d="M1206.582 438.99a9.2 9.2 0 0 1 .009.409 9.011 9.011 0 0 1-13.87 7.591 6.442 6.442 0 0 0 .757.045 6.35 6.35 0 0 0 3.932-1.357 3.178 3.178 0 0 1-2.958-2.2 3.081 3.081 0 0 0 .6.055 3.127 3.127 0 0 0 .834-.109 3.175 3.175 0 0 1-2.541-3.107.34.34 0 0 1 0-.039 3.179 3.179 0 0 0 1.434.4 3.172 3.172 0 0 1-.98-4.229 8.993 8.993 0 0 0 6.53 3.308 3.1 3.1 0 0 1-.082-.722 3.169 3.169 0 0 1 5.48-2.167 6.332 6.332 0 0 0 2.011-.77 3.168 3.168 0 0 1-1.393 1.752 6.339 6.339 0 0 0 1.82-.5 6.422 6.422 0 0 1-1.58 1.642" fill="#fff" />
                                            </g>
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="row boxStats">
                            <div className="col-6">
                                {dataState.sum_ha_under_resto > 0 &&
                                    <>
                                        <div className="divGaugeEchart">
                                            <ReactEChartsCore
                                                echarts={echarts}
                                                option={option}
                                                notMerge={true}
                                                lazyUpdate={true}
                                                theme={'theme_name'}
                                                opts={{}}
                                            />
                                        </div>
                                    </>
                                }
                                <div className='divguagetext'>
                                    <div className="bigText gaugebigText"> {dataState.ha_pledged.toLocaleString()}</div>
                                    <div className="smallText info-text label gaugelabel"><span>{t('statistics.ha_commited')}</span></div>
                                </div>
                                <div className="infograph">
                                    <img src="img/placeholder-dial.svg" alt=""></img>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="row">
                                    <div className="col-6 stats_sum">
                                        {!dataState.sum_ha_under_resto || dataState.sum_ha_under_resto.toString() == '0' ?
                                            <div className="bigText hidden"></div>
                                            :
                                            <div className="bigText">
                                                {dataState.sum_ha_under_resto?.toLocaleString()}</div>
                                        }
                                        <div className="smallText info-text label">{t('statistics.totalhaUnderRestoration')}</div>
                                    </div>
                                    <div className="col-6 stats_sum">
                                        {!dataState.sum_co2_sequestered || dataState.sum_co2_sequestered.toString() == '0' ?
                                            <div className="bigText hidden"></div>
                                            :
                                            <div className="bigText">
                                                {dataState.sum_co2_sequestered?.toLocaleString()}</div>
                                        }
                                        <div className="smallText info-text label">{t('statistics.totalCO2Sequestered')}</div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-6 stats_sum">
                                        <div className={`bigText ${(!dataState.sum_invested || dataState.sum_invested == 0) ? "hidden" : ""}`} >{t('statistics.devise')} {(dataState.sum_invested / 1000000).toFixed(2).toLocaleString()}{t('statistics.unitMillion')}</div>
                                        <div className="smallText info-text label">{t('statistics.totalAmount')}</div>
                                    </div>
                                    <div className="col-6 stats_sum">
                                        <div className={`bigText ${(!dataState.sum_eco_jobs_created || dataState.sum_eco_jobs_created == 0) ? "hidden" : ""}`} >{dataState.sum_eco_jobs_created?.toLocaleString()}</div>
                                        <div className="smallText info-text label">{t('statistics.totalEcoJobsCreated')}</div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="content-wrapper">
                            <div className="contained">

                                <div className="section-tab">
                                    <div className="tab__item">
                                        <button type="button" className="section-tab__header" onClick={() => openTab()}>
                                            <span>{t('keyinformation.title')}</span>

                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.225 13.615">
                                                <path d="m26.11 2.115-11.719 10-12.281-10" fill="none" stroke="#197058" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                                            </svg>
                                        </button>
                                        <div className="section-tab__body">
                                            <div className="inner-content">
                                                {/* <!-- Overview of indicators START --> */}
                                                <div className="section-tab__item">
                                                    <h3 className="section-tab__item-title">Overview of indicators</h3>

                                                    <div className="overview-indicators">
                                                        <div className="bg-darkgreen">
                                                            <div className="indicator-title">
                                                                <h4 className="indicator-title-header indicator-title-header__action">Action</h4>
                                                            </div>

                                                            <ul className="indicator-info">
                                                                <li>
                                                                    <span className="indicator-info__counter">1</span>
                                                                    <h5 className="indicator-info__title">Policies and institutional arrangements</h5>

                                                                    <p>put into place to advance, incentivise and trigger restoration.</p>
                                                                </li>

                                                                <li>
                                                                    <span className="indicator-info__counter">2</span>
                                                                    <h5 className="indicator-info__title">Funding</h5>

                                                                    <p>channelled into restoration by governments, companies, international donors and other entities.</p>
                                                                </li>

                                                                <li>
                                                                    <span className="indicator-info__counter">3</span>
                                                                    <h5 className="indicator-info__title">Technical planning</h5>

                                                                    <p>to determine where, how and with whom restoration should take place.</p>
                                                                </li>

                                                                <li>
                                                                    <span className="indicator-info__counter">4</span>
                                                                    <h5 className="indicator-info__title">Monitoring systems</h5>

                                                                    <p>already in place to track restoration progress.</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div className="bg-blue">
                                                            <div className="indicator-title">
                                                                <h4 className="indicator-title-header indicator-title-header__impact">Impact</h4>
                                                            </div>

                                                            <ul className="indicator-info">
                                                                <li>
                                                                    <span className="indicator-info__counter">5</span>
                                                                    <h5 className="indicator-info__title">Area of land</h5>

                                                                    <p>where functionality (ability to provide ecosystem goods and services) has been improved by restoration (not only area of direct intervention).</p>
                                                                </li>

                                                                <li>
                                                                    <span className="indicator-info__counter">6</span>
                                                                    <h5 className="indicator-info__title">Climate</h5>

                                                                    <p>and the amount of carbon sequestered via restoration.</p>
                                                                </li>

                                                                <li>
                                                                    <span className="indicator-info__counter">7</span>
                                                                    <h5 className="indicator-info__title">Biodiversity</h5>

                                                                    <p>benefits and how the creation or improvement of habitats or corridors benefits wildlife.</p>
                                                                </li>

                                                                <li>
                                                                    <span className="indicator-info__counter">8</span>
                                                                    <h5 className="indicator-info__title">Economy</h5>

                                                                    <p>particularly the number of jobs created.</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <!-- Overview of indicators END --> */}
                                                {/* <!-- Ecosystems START --> */}
                                                <div className="section-tab__item">
                                                    <h3 className="section-tab__item-title">Ecosystems</h3>

                                                    <ul className="ecosystems-list key-ecosystems-list">
                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Coasts and <br /> mangroves
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Deserts and <br />semi-deserts
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Farmlands and <br />mixed-use areas
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Forests and <br />woodlands
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Grasslands,<br /> shrub-lands <br />and savannahs
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Peatlands
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Rivers, streams <br />and lakes
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Urban areas
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="image-badge">
                                                                <div className="image-wrapper">
                                                                    <img className="imgPlaceHolder" ></img>
                                                                </div>

                                                                <div className="text-content">
                                                                    Other
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                {/* <!-- Ecosystems END --> */}

                                                {/* <!-- Interventions START --> */}
                                                <div className="section-tab__item">
                                                    <h3 className="section-tab__item-title interv-subtitle">Interventions</h3>

                                                    <div className="interventions-inner-content-wrapper">
                                                        <p className="inter-Eg">This is an example of interventions within the Peatlands Ecosystem</p>

                                                        <ul className="text-badges">
                                                            <li>
                                                                <div className="text-badge text-blue bg-thingreen"><strong>Peatlands</strong></div>
                                                            </li>
                                                        </ul>

                                                        <div className="text-contents">
                                                            <ul>
                                                                <li className="liheader">
                                                                    <p><strong className='liinterventionTypesHeaders'>Natural regeneration</strong></p>

                                                                    <ul>
                                                                        <li className='liinterventionTypes'>Passive natural regeneration</li>
                                                                        <li className='liinterventionTypes'>Reducing or eliminating the sources of degradation and allowing recovery time</li>
                                                                        <li className='liinterventionTypes'>
                                                                            Assisted natural regeneration:

                                                                            <ul>
                                                                                <li className='liinterventionTypes'>Fire prevention change to management to account for wetlands where fire regimes may be beneficial e.g. prescribed burns for bogs</li>
                                                                                <li className='liinterventionTypes'>Reintroduction of native species</li>
                                                                                <li className='liinterventionTypes'>Other (option to provide more detail)</li>
                                                                            </ul>
                                                                        </li>
                                                                    </ul>
                                                                </li>
                                                            </ul>

                                                            <ul>
                                                                <li className="liheader">
                                                                    <p><strong className='liinterventionTypesHeaders'>Artificial regeneration</strong></p>
                                                                    <ul>
                                                                        <li className='liinterventionTypes'>Re-wetting/raising water table</li>
                                                                        <li className='liinterventionTypes'>Re-vegetation by characteristic species</li>
                                                                        <li className='liinterventionTypes'>Reduction of erosion</li>
                                                                        <li className='liinterventionTypes'>Influencing water abstraction from supply aquifer</li>
                                                                        <li className='liinterventionTypes'>Reducing/halting nutrient input from catchment</li>
                                                                        <li className='liinterventionTypes'>Re-establishment of traditional mowing/grazing systems (only for Fen)</li>
                                                                    </ul>
                                                                </li>
                                                            </ul>

                                                            <ul>
                                                                <li className="liheader">
                                                                    <p><strong className='liinterventionTypesHeaders'>Land/water protection</strong></p>
                                                                    <ul>
                                                                        <li className='liinterventionTypes'>Site/area/habitat protection e.g. establishment of community conserved areas/protected areas</li>
                                                                        <li className='liinterventionTypes'>Other (option to provide more detail)</li>
                                                                    </ul>

                                                                    <br />

                                                                    <p><strong className='liinterventionTypesHeaders'>Invasive/problematic species control</strong></p>

                                                                    <br />

                                                                    <p><strong className='liinterventionTypesHeaders'>Management of invasive native species (incl. diseases)</strong></p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <br /><br /><br />

                                                        <p>For the full intervention typology please refer Section 4 within the <a href="#">Barometer Guide</a></p>
                                                    </div>
                                                </div>
                                                {/* <!-- Interventions END --> */}

                                                {/* <!-- Tiers START --> */}
                                                <div className="section-tab__item" id="section-tab__item-tiers">
                                                    <h3 className="section-tab__item-title">{t('keyinfo-Interventions.tierTitle')}</h3>

                                                    <ul className="flex cols-3">
                                                        <div className="text-badge text-badge__large bg-blue text-white">
                                                            <div className="flex flex--col justify-center align-center">
                                                                <strong>{t('keyinfo-Interventions.tier3')}</strong>
                                                                <div>
                                                                    {t('keyinfo-Interventions.tierHighConfidence')} <br /> {t('keyinfo-Interventions.accuracy')}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="text-badge text-badge__large bg-lightgreen text-white">
                                                            <div className="flex flex--col justify-center align-center">
                                                                <strong>{t('keyinfo-Interventions.tier2')}</strong>
                                                                <div>
                                                                    {t('keyinfo-Interventions.tierModerateConfidence')} <br /> {t('keyinfo-Interventions.accuracy')}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="text-badge text-badge__large bg-orange text-white">
                                                            <div className="flex flex--col justify-center align-center">
                                                                <strong>{t('keyinfo-Interventions.tier1')}</strong>
                                                                <div>
                                                                    {t('keyinfo-Interventions.tierLowConfidence')} <br /> {t('keyinfo-Interventions.accuracy')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ul>
                                                </div>
                                                {/* <!-- Tiers END --> */}

                                                {/* <!-- Tools START --> */}
                                                <div className="section-tab__item">
                                                    <h3 className="section-tab__item-title">{t('keyinfo-Tools.title')}</h3>

                                                    <div className="flex cols-3">
                                                        <div className="tile bg-white">
                                                            <h5 className="tile-title">{t('keyinfo-Tools.FAO')}</h5>

                                                            <div className="image-wrapper">

                                                            </div>

                                                            <p className="normalPara">
                                                                {t('keyinfo-Tools.Desc')}
                                                            </p>
                                                            <br />
                                                            <p className="greentxt">
                                                                <a href="" className="greentxt"> {t('keyinfo-Tools.More')}</a>
                                                            </p>
                                                        </div>

                                                        <div className="tile bg-white">
                                                            <h5 className="tile-title">{t('keyinfo-Tools.IPCC')}</h5>

                                                            <div className="image-wrapper">

                                                            </div>

                                                            <p className="normalPara">
                                                                {t('keyinfo-Tools.Desc')}
                                                            </p>
                                                            <br />

                                                            <p className="greentxt">
                                                                <a href="" className="greentxt"> {t('keyinfo-Tools.More')}</a>
                                                            </p>
                                                        </div>

                                                        <div className="tile bg-white">
                                                            <h5 className="tile-title">{t('keyinfo-Tools.IUCN_WCRD')}</h5>

                                                            <div className="image-wrapper">
                                                            </div>

                                                            <p className="normalPara">
                                                                {t('keyinfo-Tools.Desc')}
                                                            </p>
                                                            <br />

                                                            <p className="greentxt">
                                                                <a href="" className="greentxt"> {t('keyinfo-Tools.More')}</a>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Tools END  */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span className="section-divider section-divider__with-margin">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1158.003 4.003">
                                        <path d="M0,2l521.555-.9,4.516-.008,3.763-.007L1156,0" transform="translate(1.002 1.002)" fill="none" stroke="#e5e5e5" stroke-linecap="round" stroke-width="2" stroke-dasharray="3 5"></path>
                                    </svg>
                                </span>

                                {/* left side  link section */}

                                <div className="lg-flex">
                                    <div className="sidebar sticky">
                                        <div className="indicators">
                                            <p className="indicators__title text-darkgreen">{t('keyinformation.subtitle')}</p>

                                            <ul>
                                                <li className="flex--col">
                                                    <span className="text-darkgreen uppercase indicators__list-title">{t('keyinfo-action.title')}</span>

                                                    <ul>
                                                        {sectionData.policies.attributes.length > 0 &&
                                                            <li>
                                                                <a href="#tab-policies-and-institutional-arrangements" className="flex items-center tab-content-link tabPolicy">
                                                                    <span className="flex items-center justify-center text-white indicator__counter">1</span>
                                                                    <span className="text-green indicator__text">{t('keyinfo-action.subtitle1')}</span>
                                                                </a>
                                                            </li>
                                                        }
                                                        {dataState.display_financial_flows && (sectionData.financialFlows.chartConfig.data.datasets.length > 0 && sectionData.financialFlows.chartConfig.data.datasets[0] as any).data &&
                                                            <li>
                                                                <a href="#tab-funding" className="flex items-center tab-content-link tabFunding">
                                                                    <span className="flex items-center justify-center text-white indicator__counter">2</span>
                                                                    <span className="text-green indicator__text">{t('keyinfo-action.subtitle2')}</span>
                                                                </a>
                                                            </li>
                                                        }
                                                        {sectionData.technicalPlanning.attributes.length > 0 &&
                                                            <li>
                                                                <a href="#tab-technical-planning" className="flex items-center tab-content-link tabPlan">
                                                                    <span className="flex items-center justify-center text-white indicator__counter">3</span>
                                                                    <span className="text-green indicator__text">{t('keyinfo-action.subtitle3')}</span>
                                                                </a>
                                                            </li>
                                                        }
                                                        {sectionData.monitoringSystems.attributes.length > 0 &&
                                                            <li>
                                                                <a href="#tab-monitoring-systems" className="flex items-center tab-content-link tabMonitoring">
                                                                    <span className="flex items-center justify-center text-white indicator__counter">4</span>
                                                                    <span className="text-green indicator__text">{t('keyinfo-action.subtitle4')}</span>
                                                                </a>
                                                            </li>
                                                        }
                                                    </ul>
                                                </li>
                                                <li className="flex--col">
                                                    <span className="text-darkgreen uppercase indicators__list-title indicators__list-title__impact">{t('keyinfo-impact.title')}</span>

                                                    <ul>
                                                        {sectionData.areaOfLand.attributes.length > 0 &&
                                                            <li>
                                                                <a href="#tab-area-of-land" className="flex items-center tab-content-link tabArea">
                                                                    <span className="flex items-center justify-center text-white indicator__counter">5</span>
                                                                    <span className="text-green indicator__text">{t('keyinfo-impact.subtitle5')}</span>
                                                                </a>
                                                            </li>
                                                        }
                                                        {sectionData.climate.attributes.length > 0 && dataState.sum_co2_sequestered != 0 && dataState.sum_co2_sequestered != null &&
                                                            <li>
                                                                <a href="#tab-climate" className="flex items-center tab-content-link tabClimate">
                                                                    <span className="flex items-center justify-center text-white indicator__counter">6</span>
                                                                    <span className="text-green indicator__text">{t('keyinfo-impact.subtitle6')}</span>
                                                                </a>
                                                            </li>
                                                        }
                                                        {!sectionData.biodiversity.chartConfigBiodiversity.data.datasets[0].data.every(item => item === 0) &&
                                                            <li>
                                                                <a href="#tab-biodiversity-benefits" className="flex items-center tab-content-link tabBiodiversity">
                                                                    <span className="flex items-center justify-center text-white indicator__counter">7</span>
                                                                    <span className="text-green indicator__text">{t('keyinfo-impact.subtitle7')}</span>
                                                                </a>
                                                            </li>
                                                        }
                                                        {sectionData.economy.attributes.length > 0 && dataState.sum_eco_jobs_created && dataState.sum_eco_jobs_created != 0 &&
                                                            <li>
                                                                <a href="#tab-economy" className="flex items-center tab-content-link tabEconomy">
                                                                    <span className="flex items-center justify-center text-white indicator__counter">8</span>
                                                                    <span className="text-green indicator__text">{t('keyinfo-impact.subtitle8')}</span>
                                                                </a>
                                                            </li>
                                                        }
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* End of left side sticy section */}
                                    <div className="content">
                                        {/* <!-- 1. Policies and institutional arrangements start --> */}
                                        {sectionData.policies.attributes.length > 0 &&
                                            <>
                                                <div className="tab-content newprintpage" id="tab-policies-and-institutional-arrangements" onMouseMove={() => showCurrentTab('tabPolicy', 'policiesLst')}>
                                                    <h3 className="lg-flex items-center text-blue tab-content__title">
                                                        <span className="flex items-center justify-center text-white indicator__counter">1</span>
                                                        <span className="text-blue indicator__text"><strong>{t('policiesAndInstitutions.title')}</strong></span>

                                                    </h3>

                                                    <div className="collapsable" id="policiesLst">
                                                        {sectionData.policies.attributes.map((item, index) => {
                                                            return (
                                                                <div className={`collapsabel__item ${index == 0 ? "open" : (index > 4 ? "hidden" : "")}`}>
                                                                    <button type="button" className="collapsabel__item__header" onClick={() => openPolicyTab(index, 'policiesLst')}>
                                                                        <span className="tile-title">{item['name']}</span>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.225 13.615">
                                                                            <path d="m26.11 2.115-11.719 10-12.281-10" fill="none" stroke="#197058" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                                                                        </svg>
                                                                    </button>

                                                                    <div className={`collapsabel__item__body ${index == 0 ? "heightAutoAccordion" : "heightAccordion"}`}>
                                                                        <div>
                                                                            <ul>
                                                                                <li><strong>{t('policiesAndInstitutions.year')}</strong><span className="normaltxt">{item['year_enacted']}</span></li>
                                                                                <li><strong>{t('policiesAndInstitutions.noofhectargeted')}</strong><span className="normaltxt">{item['ha_targeted']}</span></li>
                                                                                <li><strong>{t('policiesAndInstitutions.Impinstit')}</strong><span className="normaltxt">{item['responsible']}</span></li>
                                                                            </ul>
                                                                            <p>
                                                                                <strong>{t('policiesAndInstitutions.Ref')}</strong>
                                                                                <span className="normaltxt"><a href={item['links']} rel="noreferrer" target="_blank">{item['links']}</a></span>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                        {sectionData.policies.attributes.length > 4 &&
                                                            <button type="button" className="btn-view-more" onClick={() => viewMoreDetails('policiesLst')}>View more</button>
                                                        }
                                                    </div>
                                                    <div className="tab-content__footer">
                                                        <h5 className="tab-content__footer--title text-blue">
                                                            <span>{t('Contributed.title')}</span>
                                                        </h5>

                                                        <ul className="contributor-logos">
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                {/* <!-- 1. Policies and institutional arrangements end --> */}
                                                <span className="section-divider">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1158.003 4.003">
                                                        <path d="M0,2l521.555-.9,4.516-.008,3.763-.007L1156,0" transform="translate(1.002 1.002)" fill="none" stroke="#e5e5e5" stroke-linecap="round" stroke-width="2" stroke-dasharray="3 5" />
                                                    </svg>
                                                </span>
                                            </>
                                        }
                                        {/* <!-- 2. Funding start --> */}
                                        {dataState.display_financial_flows && (sectionData.financialFlows.chartConfig.data.datasets.length > 0 && sectionData.financialFlows.chartConfig.data.datasets[0] as any).data &&
                                            <>
                                                <div className="tab-content" id="tab-funding" onMouseMove={() => showCurrentTab('tabFunding', 'tab-funding')}>
                                                    <h3 className="lg-flex items-center text-blue tab-content__title">
                                                        <span className="flex items-center justify-center text-white indicator__counter">2</span>
                                                        <span className="text-blue indicator__text">{t('funding.title')}</span>
                                                    </h3>

                                                    <div className="yellow-badge">
                                                        <div className="illustration">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 80">
                                                                <g data-name="Group 4486" fill="#001440">
                                                                    <path data-name="Path 1565" d="M52.383 23.049v-1.706a4.311 4.311 0 0 0-1.44-8.378 1.44 1.44 0 1 1 1.44-1.44 1.44 1.44 0 0 0 2.881 0 4.321 4.321 0 0 0-2.881-4.056V5.763a1.44 1.44 0 0 0-2.881 0v1.706a4.311 4.311 0 0 0 1.44 8.378 1.44 1.44 0 1 1-1.44 1.44 1.44 1.44 0 1 0-2.881 0 4.321 4.321 0 0 0 2.881 4.056v1.705a1.44 1.44 0 1 0 2.881 0" />
                                                                    <path data-name="Path 1566" d="M1.455 79.999h20.37a1.459 1.459 0 0 0 1.44-1.41l24.9 1.207c.164.009.327.012.492.012a10.062 10.062 0 0 0 7.582-3.455l17.68-20.11a8.456 8.456 0 0 0-.652-11.791 8.094 8.094 0 0 0-11.217.274l-9.666 9.69V41.46a11.717 11.717 0 0 0 3.773.684 9.7 9.7 0 0 0 3.937-.83c5.829-2.565 8.136-10.193 8.23-10.515a1.486 1.486 0 0 0-.976-1.844 1.43 1.43 0 0 0-.285-.056c-6.419-.593-11.236.56-14.323 3.431-.128.119-.242.24-.359.36v-3.135A14.748 14.748 0 0 0 65.4 13.333a14.555 14.555 0 1 0-28.952 2.966A14.686 14.686 0 0 0 49.47 29.555v5.692c-.192-.207-.4-.413-.614-.616-3.347-3.1-8.564-4.351-15.522-3.7a1.474 1.474 0 0 0-1.318 1.609 1.519 1.519 0 0 0 .055.292c.1.351 2.6 8.615 8.909 11.388a10.422 10.422 0 0 0 4.243.889 12.735 12.735 0 0 0 4.247-.794v8.483l-5.995-5.13a7.214 7.214 0 0 0-4.681-1.736H23.28a1.469 1.469 0 0 0-1.455-1.481H1.455A1.469 1.469 0 0 0 0 45.926v32.592a1.469 1.469 0 0 0 1.455 1.481m53.293-45.527c2.164-1.981 5.558-2.905 10.106-2.75-.93 2.114-2.847 5.527-5.928 6.877a7.941 7.941 0 0 1-6.425-.234 7.344 7.344 0 0 1 2.247-3.893m-12.604 7.027c-3.492-1.529-5.621-5.444-6.616-7.752 5.093-.2 8.9.816 11.32 3.032a8.142 8.142 0 0 1 2.51 4.424 8.812 8.812 0 0 1-7.214.3m-2.859-26.687a11.642 11.642 0 1 1 23.28 0 11.642 11.642 0 1 1-23.28 0m-.49 34.073a4.325 4.325 0 0 1 2.805 1.037l9.257 7.921a3 3 0 0 1 .356 4.163 2.866 2.866 0 0 1-4.087.366l-3.239-2.777a1.438 1.438 0 0 0-2.052.182 1.5 1.5 0 0 0 .179 2.087l3.239 2.77a5.739 5.739 0 0 0 8.186-.718l.006-.007a6.011 6.011 0 0 0 .5-6.911l10.14-10.172a5.224 5.224 0 0 1 7.483.077 5.458 5.458 0 0 1 .175 7.352L54.067 74.377a7.211 7.211 0 0 1-5.767 2.459l-25.02-1.213V48.889ZM2.91 47.408h17.46v29.628H2.91Z" />
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div className="text-content">
                                                            {

                                                                dataState.display_financial_flows && (sectionData.financialFlows.chartConfig.data.datasets.length > 0 && sectionData.financialFlows.chartConfig.data.datasets[0] as any).data &&
                                                                <p><strong id="totInvestment">
                                                                    {t('statistics.devise')}{((sectionData.financialFlows.chartConfig.data.datasets[0] as any).data.total / 1000000).toFixed(2).toLocaleString()}{t('statistics.unitMillion')}
                                                                </strong>
                                                                    <span className="uppercase">{t('funding.totInvesmentlbl')}</span></p>
                                                            }

                                                        </div>
                                                    </div>
                                                    <div className="tile">
                                                        <h4 className="tile-title txtleft fontB">{t('funding.heading')}</h4>
                                                        {sectionData.financialFlows.attributes.map((item, index) => {
                                                            if (item['amount'] > 0)
                                                                return (

                                                                    <div className="tile__body">
                                                                        <div className="flex flex-mobile-col-reverse">
                                                                            <div className="illustration mobile-align-self-end">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 107 107">
                                                                                    <defs>
                                                                                        <clipPath id="domestic_a">
                                                                                            <path data-name="Rectangle 3613" fill="none" d="M0 0h56.047v69.117H0z" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                    <g transform="translate(-28 -714)">
                                                                                        <circle data-name="Ellipse 113" cx="53.5" cy="53.5" r="53.5" transform="translate(28 714)" fill="#fff" />
                                                                                        <g data-name="Funding Icon">
                                                                                            <g data-name="Group 4326" transform="translate(53 733.727)" clip-path="url(#domestic_a)" fill="none" stroke="#001440" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                                                                                <path data-name="Path 1581" d="M42.454 54.964h0a2.136 2.136 0 0 0 2.816 1.026l1.669-.964a2.135 2.135 0 0 0 .52-2.951l-.321-.555a2.3 2.3 0 0 0-2.229-1.228l-3.349.49a2.3 2.3 0 0 1-2.229-1.228l-.321-.555a2.135 2.135 0 0 1 .52-2.951l1.669-.964a2.136 2.136 0 0 1 2.815 1.024" />
                                                                                                <path data-name="Line 17" d="m39.217 43.577 1.149 1.988" />
                                                                                                <path data-name="Line 18" d="m46.105 55.507 1.148 1.988" />
                                                                                                <ellipse data-name="Ellipse 116" cx="13" cy="5.5" rx="13" ry="5.5" transform="translate(1 26.273)" />
                                                                                                <path data-name="Line 19" d="M27 37.273v-5" />
                                                                                                <ellipse data-name="Ellipse 117" cx="13" cy="6" rx="13" ry="6" transform="translate(23 1.273)" />
                                                                                                <path data-name="Path 1582" d="M31.912 30.028a28.028 28.028 0 0 0 4.2.309c7.18 0 13-2.587 13-5.779v-8.667" />
                                                                                                <path data-name="Line 20" d="M23.115 15.891v6.381" />
                                                                                                <path data-name="Line 21" d="M49.118 35.153V24.559" />
                                                                                                <path data-name="Path 1583" d="M23.115 7.223v8.668c0 3.191 5.821 5.779 13 5.779s13-2.587 13-5.779V7.223" />
                                                                                                <path data-name="Path 1584" d="M1.445 40.45v8.668c0 3.191 5.821 5.779 13 5.779a26.041 26.041 0 0 0 6.911-.883" />
                                                                                                <path data-name="Path 1585" d="M1.445 31.782v8.668c0 3.191 5.821 5.779 13 5.779a25.726 25.726 0 0 0 7.22-.972" />
                                                                                                <path data-name="Path 1586" d="M1.445 49.118v8.668c0 3.191 5.821 5.779 13 5.779a22.7 22.7 0 0 0 9.619-1.891" />
                                                                                                <path data-name="Path 1587" d="M52.008 45.508c3.989 6.91 3.3 14.775-1.534 17.567s-11.992-.545-15.981-7.454-3.3-14.775 1.534-17.567 11.991.542 15.981 7.454Z" />
                                                                                                <path data-name="Path 1588" d="m36.026 38.052-6.255 3.612c-4.837 2.793-5.524 10.657-1.534 17.567s11.144 10.248 15.981 7.456l6.255-3.612" />
                                                                                            </g>
                                                                                        </g>
                                                                                    </g>
                                                                                </svg>
                                                                            </div>

                                                                            <div className="text-content domesticPublicDiv borderstyle">

                                                                                <ul className="no-border txtleft nopadding">
                                                                                    <li>
                                                                                        <strong>Category:</strong> <span className="normaltxt" id="publicExpense">{item['type']}</span>
                                                                                    </li>

                                                                                    <li>
                                                                                        <strong>Amount:</strong> <span className="normaltxt" id="publicExpense">{t('statistics.devise')} {(item['amount'] as any).toLocaleString()}</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <strong>Tier:</strong> <span className="normaltxt" id="spnTier">{item['tier']}</span>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                        })}
                                                    </div>

                                                    <div className="tab-content__footer">
                                                        <h5 className="tab-content__footer--title text-blue">
                                                            <span>{t('Contributed.title')}</span>
                                                        </h5>

                                                        <ul className="contributor-logos">
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <span className="section-divider">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1158.003 4.003">
                                                        <path d="M0,2l521.555-.9,4.516-.008,3.763-.007L1156,0" transform="translate(1.002 1.002)" fill="none" stroke="#e5e5e5" stroke-linecap="round" stroke-width="2" stroke-dasharray="3 5" />
                                                    </svg>
                                                </span>
                                            </>
                                        }
                                        {/* <!-- 2. Funding end --> */}

                                        {/* <!-- 3. Technical Planning start --> */}
                                        {sectionData.technicalPlanning.attributes.length > 0 &&
                                            <>
                                                <div className="tab-content" id="tab-technical-planning" onMouseMove={() => showCurrentTab('tabPlan', 'tab-technical-planning')}>
                                                    <h3 className="lg-flex items-center text-blue tab-content__title">
                                                        <span className="flex items-center justify-center text-white indicator__counter">3</span>
                                                        <span className="text-blue indicator__text">{t('technicalPlanning.title')}</span>
                                                    </h3>

                                                    <div className="collapsable" id="divTechPlan">
                                                        {sectionData.technicalPlanning.attributes.map((item, index) => {
                                                            return (
                                                                <div className={`collapsabel__item ${index == 0 ? "open" : (index > 4 ? "hidden" : "")}`}>
                                                                    <button type="button" className="collapsabel__item__header" onClick={() => openPolicyTab(index, 'divTechPlan')}>
                                                                        <span className="tile-title">{item['methodology']}</span>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.225 13.615">
                                                                            <path d="m26.11 2.115-11.719 10-12.281-10" fill="none" stroke="#197058" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                                                                        </svg>
                                                                    </button>

                                                                    <div className={`collapsabel__item__body ${index == 0 ? "heightAutoAccordion" : "heightAccordion"}`}>
                                                                        <div>
                                                                            <p>
                                                                                <ul>
                                                                                    <li>
                                                                                        <span className="normaltxt">{item['description']}</span>
                                                                                    </li>
                                                                                </ul>
                                                                            </p>
                                                                            <ul>
                                                                                <li><strong>{t('technicalPlanning.scale')}</strong><span className="normaltxt">{item['scale']}</span></li>
                                                                                <li><strong>{t('technicalPlanning.ScaleObserv')}</strong><span className="normaltxt">{item['obs_scale']}</span></li>
                                                                                <li><strong>{t('technicalPlanning.PreDomStatus')}</strong>
                                                                                    {sectionData.technicalPlanning.refattributes.length > 0 &&
                                                                                        <span className="normaltxt">{sectionData.technicalPlanning.refattributes[index]}</span>
                                                                                    }
                                                                                </li>
                                                                            </ul>
                                                                            <p>
                                                                                <strong>{t('technicalPlanning.Ref')}</strong>
                                                                                <a href={item['links']} rel="noreferrer" target="_blank"><span className="normaltxt">{item['links']}</span></a>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                        {sectionData.technicalPlanning.attributes.length > 4 &&
                                                            (
                                                                <button type="button" className="btn-view-more" onClick={() => viewMoreDetails('divTechPlan')}>View more</button>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="tab-content__footer">
                                                        <h5 className="tab-content__footer--title text-blue">
                                                            <span>{t('Contributed.title')}</span>
                                                        </h5>

                                                        <ul className="contributor-logos">
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                {/* <!-- 3. Technical Planning end --> */}

                                                <span className="section-divider">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1158.003 4.003">
                                                        <path d="M0,2l521.555-.9,4.516-.008,3.763-.007L1156,0" transform="translate(1.002 1.002)" fill="none" stroke="#e5e5e5" stroke-linecap="round" stroke-width="2" stroke-dasharray="3 5" />
                                                    </svg>
                                                </span>
                                            </>
                                        }
                                        {/* <!-- 4. Monitoring systems start --> */}
                                        {sectionData.monitoringSystems.attributes.length > 0 &&
                                            <>
                                                <div className="tab-content" id="tab-monitoring-systems" onMouseMove={() => showCurrentTab('tabMonitoring', 'tab-monitoring-systems')}>
                                                    <h3 className="lg-flex items-center text-blue tab-content__title">
                                                        <span className="flex items-center justify-center text-white indicator__counter">4</span>
                                                        <span className="text-blue indicator__text">{t('monitoringSystem.title')}</span>
                                                    </h3>

                                                    <div className="collapsable" id="divMonitoringSystem">
                                                        {sectionData.monitoringSystems.attributes.map((item, index) => {
                                                            return (
                                                                <div className={`collapsabel__item ${index == 0 ? "open" : (index > 4 ? "hidden" : "")}`}>
                                                                    <button type="button" className="collapsabel__item__header" onClick={() => openPolicyTab(index, 'divMonitoringSystem')}>
                                                                        <span className="tile-title">{item['monitoring_system']}</span>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.225 13.615">
                                                                            <path d="m26.11 2.115-11.719 10-12.281-10" fill="none" stroke="#197058" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                                                                        </svg>
                                                                    </button>

                                                                    <div className={`collapsabel__item__body ${index == 0 ? "heightAutoAccordion" : "heightAccordion"}`}>
                                                                        <div>
                                                                            <p>
                                                                                <ul>
                                                                                    <li>
                                                                                        <span className="normaltxt">{item['description']}</span>
                                                                                    </li>
                                                                                </ul>
                                                                            </p>
                                                                            <ul>
                                                                                <li><strong>{t('monitoringSystem.MangInst')}</strong> <span className="normaltxt">{item['managing_instit']}</span></li>
                                                                                <li><strong>{t('monitoringSystem.scale')}</strong> <span className="normaltxt">{item['geo_scale']}</span></li>
                                                                                <li><strong>{t('monitoringSystem.track')}</strong> <span className="normaltxt"></span></li>
                                                                            </ul>
                                                                            <p>
                                                                                <strong>References:</strong>
                                                                                <a href={item['links']} rel="noreferrer" target="_blank"><span className="normaltxt">{item['links']}</span></a>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                        {sectionData.monitoringSystems.attributes.length > 4 &&
                                                            (
                                                                <button type="button" className="btn-view-more" onClick={() => viewMoreDetails('divMonitoringSystem')}>View more</button>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="tab-content__footer">
                                                        <h5 className="tab-content__footer--title text-blue">
                                                            <span>{t('Contributed.title')}</span>
                                                        </h5>

                                                        <ul className="contributor-logos">
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                {/* <!-- 4. Monitoring systems end --> */}

                                                <span className="section-divider">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1158.003 4.003">
                                                        <path d="M0,2l521.555-.9,4.516-.008,3.763-.007L1156,0" transform="translate(1.002 1.002)" fill="none" stroke="#e5e5e5" stroke-linecap="round" stroke-width="2" stroke-dasharray="3 5" />
                                                    </svg>
                                                </span>
                                            </>
                                        }
                                        {/* {/ <!-- 5. Area of land start --> /} */}
                                        {sectionData.areaOfLand.attributes.length > 0 &&
                                            <>
                                                <div className="tab-content" id="tab-area-of-land" onMouseMove={() => showCurrentTab('tabArea', 'tab-area-of-land')}>
                                                    <h3 className="lg-flex items-center text-blue tab-content__title">
                                                        <span className="flex items-center justify-center text-white indicator__counter">5</span>
                                                        <span className="text-blue indicator__text">{t('areaOfLand.title')}</span>
                                                    </h3>

                                                    <div className="yellow-badge">
                                                        <div className="illustration">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 80">
                                                                <path data-name="Path 1556" d="m45 0-.924.921a52.339 52.339 0 0 0-12.335 19.94C29.215 16.72 25.7 12.918 21.5 8.609l-.924-.921-.924.921c-8.724 8.942-14.5 15.8-14.5 27.828a32.712 32.712 0 0 0 14.134 27.547v13.454H0V80h60.429v-2.562H46.286V61.422A32.26 32.26 0 0 0 56.612 49.85a32.057 32.057 0 0 0 11.531 14.134V80H90v-2.562H70.714V63.984a32.711 32.711 0 0 0 14.143-27.548c0-12.032-5.781-18.886-14.5-27.828l-.924-.921-.924.921c-4.2 4.31-7.719 8.112-10.246 12.252A52.341 52.341 0 0 0 45.924.921Zm0 3.843c7.907 8.55 12.858 19.247 12.858 30.03a29.982 29.982 0 0 1-11.572 24.264V44.684l7.232-6.006-1.607-1.962-5.625 4.684V30.59l7.232-6.006-1.607-1.962-5.625 4.684V18.5h-2.571v13.932l-5.625-4.685-1.607 1.962 7.232 6.006v10.811l-5.625-4.685-1.607 1.959 7.232 6.006v8.328a29.984 29.984 0 0 1-11.572-24.261c0-10.783 4.95-21.48 12.857-30.03Zm-24.429 7.568c4.465 4.619 8 8.586 10.165 12.932a40.593 40.593 0 0 0-1.165 9.53 34.893 34.893 0 0 0 2.29 12.693 29.4 29.4 0 0 1-10 14.174V47.247l7.232-6.006-1.607-1.962-5.625 4.684v-8.248l7.232-6.006-1.607-1.962-5.625 4.685v-8.809h-2.575v13.934l-5.625-4.684-1.607 1.962 7.232 6.006v8.248L13.661 44.4l-1.607 1.962 7.232 6.006v8.292A29.949 29.949 0 0 1 7.714 36.436c0-10.787 4.806-16.708 12.857-25.025Zm48.857 0c8.051 8.318 12.858 14.238 12.858 25.025a29.952 29.952 0 0 1-11.573 24.225V47.248l7.232-6.006-1.607-1.962-5.625 4.684v-8.248l7.232-6.006-1.607-1.962-5.625 4.685v-8.809h-2.571v13.934l-5.625-4.684-1.607 1.961 7.233 6.006v8.249l-5.625-4.684-1.608 1.961 7.233 6.006v8.369a29.4 29.4 0 0 1-10-14.174 34.893 34.893 0 0 0 2.29-12.693 40.585 40.585 0 0 0-1.165-9.53c2.162-4.347 5.7-8.313 10.165-12.932ZM33.387 49.849A32.255 32.255 0 0 0 43.713 61.42v16.017H21.856V63.983a32.057 32.057 0 0 0 11.531-14.134Z" fill="#001440" />
                                                            </svg>
                                                        </div>

                                                        <div className="text-content">
                                                            {(!dataState.sum_ha_under_resto || dataState.sum_ha_under_resto.toString() == '0') ?
                                                                <p><strong id="totArea">0,00</strong>
                                                                    <span className="uppercase areaYellowTitle">TOTAL HA UNDER RESTORATION</span></p>
                                                                :
                                                                <p><strong id="totArea">{dataState.sum_ha_under_resto?.toLocaleString()}</strong>
                                                                    <span className="uppercase areaYellowTitle">TOTAL HA UNDER RESTORATION</span></p>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="inner-content inner-contentdetailmap">
                                                        <div className="popover hidden">
                                                            <div className="popover__header">
                                                                <button type="button" className="btn-close" onClick={() => closePopup()}>
                                                                </button>

                                                            </div>
                                                            <h5 className="popover__title popover__titleinvst">Investments</h5>
                                                            <div className="popover__body">
                                                                <table className="tblAreaPopup">
                                                                    {sectionData.areaOfLand.attributes[0]["ha_under_resto"] > 0 &&
                                                                        <>
                                                                            <tr>
                                                                                <td>Ha under restoration</td>
                                                                                <td>{(sectionData.areaOfLand.attributes[0]["ha_under_resto"] as any).toLocaleString()}</td>
                                                                            </tr>
                                                                        </>
                                                                    }
                                                                    {sectionData.areaOfLand.attributes[0]["co2_sequestered"] > 0 &&
                                                                        <>
                                                                            <tr>
                                                                                <td>CO2 sequestered</td>
                                                                                <td>{(sectionData.areaOfLand.attributes[0]["co2_sequestered"] as any).toLocaleString()}</td>
                                                                            </tr>
                                                                        </>
                                                                    }
                                                                    {sectionData.areaOfLand.attributes[0]["bio_protarea_ha"] > 0 &&
                                                                        <>
                                                                            <tr>
                                                                                <td>Ha under restoration (protected area)</td>
                                                                                <td>{(sectionData.areaOfLand.attributes[0]["bio_protarea_ha"] as any).toLocaleString()}</td>
                                                                            </tr>
                                                                        </>
                                                                    }
                                                                    {sectionData.areaOfLand.attributes[0]["eco_jobs_created"] > 0 &&
                                                                        <>
                                                                            <tr>
                                                                                <td>Jobs created</td>
                                                                                <td>{(sectionData.areaOfLand.attributes[0]["eco_jobs_created"] as any).toLocaleString()}</td>
                                                                            </tr>
                                                                        </>
                                                                    }
                                                                    {(sectionData.areaOfLand.attributes[0]["ha_intervention_types_values"] as any).length > 0 &&
                                                                        <>
                                                                            <tr>
                                                                                <td>Intervention type</td>

                                                                                <td> {(sectionData.areaOfLand.attributes[0]["ha_intervention_types_values"] as any).length}</td>
                                                                            </tr>
                                                                        </>
                                                                    }
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="map-wrapper map-wrapperdetails">

                                                        {state.activitiesPointFeatures.length > 0 || state.activitiesPolygonFeatures.length > 0 &&
                                                            <>
                                                                <div className="divActivitiesMap">
                                                                    <ActivitiesMap reportId={dataState.reportid} key={state.reloadKey}
                                                                        activitiesPointFeatures={state.activitiesPointFeatures}
                                                                        activitiesPolygonFeatures={state.activitiesPolygonFeatures} onSelectedFeature={onSelectedFeature} />
                                                                </div>
                                                            </>
                                                        }

                                                        {state.activitiesPointFeatures.length == 0 && state.activitiesPolygonFeatures.length == 0 &&
                                                            <>
                                                                <div className="divAreaMap">
                                                                    <MapArea ref={mapAreaRef} reports={dataState.reports} countries={dataState.countries} states={dataState.states} onSelectedFeature={onSelectedFeature} />
                                                                </div>
                                                            </>
                                                        }
                                                    </div>

                                                    <div className="collapsable" id="divAreaofLand">
                                                        <SectionInterventionTypesList rbList={sectionData.relatedRB} openTabEvent={openAccordionTab} />
                                                        {sectionData.areaOfLand.attributes.length > 4 &&
                                                            <button type="button" className="btn-view-more" onClick={() => viewMoreDetails('divAreaofLand')}>View more</button>
                                                        }
                                                    </div>
                                                    <div className="tab-content__footer">
                                                        <h5 className="tab-content__footer--title text-blue">
                                                            <span>{t('Contributed.title')}</span>
                                                        </h5>

                                                        <ul className="contributor-logos">
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                {/* {/ <!-- 5. Area of land end --> /} */}
                                                <span className="section-divider">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1158.003 4.003">
                                                        <path d="M0,2l521.555-.9,4.516-.008,3.763-.007L1156,0" transform="translate(1.002 1.002)" fill="none" stroke="#e5e5e5" stroke-linecap="round" stroke-width="2" stroke-dasharray="3 5" />
                                                    </svg>
                                                </span>
                                            </>
                                        }
                                        {/* {/ <!-- 6.Climate start --> /} */}
                                        {sectionData.climate.attributes.length > 0 && dataState.sum_co2_sequestered != 0 && dataState.sum_co2_sequestered != null &&
                                            <>
                                                <div className="tab-content" id="tab-climate" onMouseMove={() => showCurrentTab('tabClimate', 'tab-climate')}>
                                                    <h3 className="lg-flex items-center text-blue tab-content__title">
                                                        <span className="flex items-center justify-center text-white indicator__counter">6</span>
                                                        <span className="text-blue indicator__text">{t('climate.title')}</span>
                                                    </h3>

                                                    <div className="yellow-badge">
                                                        <div className="illustration">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80.9">
                                                                <path fill="#001440" d="M5.6 30.9c-.4 0-.8-.2-1-.5-1.2-2.1-2-4.4-2.6-6.7-1.2-5.2-.6-9.9 1.7-13.7 4.6-7.2 9.7-6.7 12.4-5.7.6.2.9.8.7 1.4s-.8.9-1.4.7c-2.5-.9-6.2-.8-9.7 4.8-3.1 4.9-2 10.7-.7 14.4.1-.2.1-.5.2-.7 1-3.4 3.9-5.8 7.4-6.4 2.7-.5 4.5-1.6 5.4-3.3 1.5-3-.2-6.9-.3-7.1-.3-.5-.1-1.2.5-1.5.5-.3 1.2-.1 1.5.4.4.7 2.2 5.2.5 9-1.1 2.5-3.5 4.1-7.1 4.7-2.7.4-4.9 2.2-5.7 4.8-.4 1.3-.6 2.8-.6 4.2 0 .6-.5 1.2-1.2 1.2.1 0 0 0 0 0zm12-22.7s.1 0 0 0" />
                                                                <path fill="#001440" d="M23.3 59.8c-.6 0-1.3-.1-1.9-.3-.6-.2-.9-.8-.8-1.4.2-.6.8-.9 1.4-.8h.1c1 .3 2.1.2 3.1-.2.3-.1.6-.3.8-.6.2-.4.2-.9.2-1.3-.1-.8.1-1.5.3-2.3.7-1.2 1.9-2 3.2-2.2.4-.1.7-.1 1.1-.2.6-.1 1.1-.2 1.7-.4.2-.1.3-.2.5-.3.1-.3.1-.6.1-1l-.2-2.1c-.1-1-.3-1.1-.3-1.2h-1.3c-1.5 0-2.9-.7-3.7-2-.2-.4-.4-.7-.5-1.1-.1-.3-.2-.5-.3-.8-.4-.6-1.2-.9-1.9-.8-1.4.3-2.7-.9-3.4-2.1-.7-1.1-.7-2.6 0-3.7.6-.8 1.4-1.4 2.3-1.7.7-.3 1.4-.7 2-1.3.5-.6.7-1.3.7-2.1L25 29c-1.5-.8-2.7-1.4-2.7-2.7 0-1.4 1.5-1.4 2.1-1.4.3 0 .5 0 .8-.1 0-.3-.1-.5-.2-.8-.4-.7-.4-1.6-.1-2.3.5-.7 1.4-1.2 2.3-1.2h.3c.8-2.9 2.8-5.3 5.5-6.7.6-.3 1.2 0 1.5.5.3.6 0 1.2-.5 1.5-2.2 1.2-3.9 3.3-4.4 5.7-.3 1-1.3 1.1-2 1.2-.2 0-.4.1-.6.1 0 .1.1.2.1.3.5.9.5 2 .1 2.9-.3.4-.7.7-1.1.8l.1.1c1.5.8 2.8 1.5 2.7 2.7 0 1.3-.5 2.6-1.3 3.7-.8.8-1.7 1.4-2.7 1.9-.5.2-1 .5-1.4.9-.5.9-.5 1.5-.2 1.9.2.4.6.8 1 1 1.7-.3 3.4.4 4.3 1.8.2.4.4.7.5 1.1.1.3.2.5.3.8.4.6 1 .9 1.7.9h.4c.6-.1 1.3-.1 1.9.2 1.4.7 1.5 2.4 1.6 3l.2 2.1c.1.8 0 1.6-.4 2.3-.4.6-.9 1-1.5 1.2-.7.3-1.5.4-2.2.5-.3 0-.6.1-.9.1-.4.1-1.4.3-1.6.9-.1.4-.2.9-.1 1.3.1.9-.1 1.7-.5 2.5-.4.7-1 1.2-1.7 1.5-1.1.4-2 .6-3 .6z" />
                                                                <path fill="#001440" d="M42.1 31.6c-.4 0-.7-.1-1-.2-1.5-.5-2.8-1.3-3.9-2.4-1.6-1.4-2.4-3.5-2-5.6.3-1.3.8-2.5 1.6-3.6-.6-.2-1.2-.4-1.8-.8-1.2-.6-2.2-1.7-2.6-3.1-.2-.6.1-1.2.7-1.4.6-.2 1.2.1 1.4.7.3.8.8 1.4 1.5 1.7.9.4 1.8.7 2.8.9.6.1 1 .8.8 1.4 0 .1-.1.2-.2.3-.9 1.2-1.6 2.6-2.1 4.1-.1 1.3.4 2.7 1.4 3.5.9.8 1.9 1.5 3 1.9.1 0 .2.1.3.1.2-.2.3-.3.4-.5.3-.5.7-.9 1.1-1.2 1-.5 2.2-.6 3.2-.1.2 0 .3.1.5.1 2 .4 4.1-.5 5.2-2.3-.2-.1-.3-.2-.5-.2-1.5-.6-2.8-1.5-3.8-2.8-1.4-2.1-1.2-4.8.4-6.6.4-.5 1.1-.5 1.6-.1s.5 1.1.1 1.6c-.9 1.1-1 2.7-.3 3.9.8.9 1.8 1.6 2.9 2.1l.6.3c.5.2.8.6 1.1 1 .2.6.2 1.3-.2 1.9-1.5 2.7-4.6 4.1-7.7 3.5-.2 0-.4-.1-.5-.1-.6-.1-1.2-.3-1.4-.1-.2.2-.3.4-.5.6-.4.7-1 1.2-1.8 1.4 0 .1-.1.1-.3.1z" />
                                                                <path fill="#001440" d="M36.9 67.4c-.2 0-.3 0-.5-.1-.5-.3-.8-.9-.5-1.5 0-.4-.1-.8-.3-1.2-.2-.6-.4-1.3-.4-1.9-.1-1-.9-2-1.8-3-.6-.6-1.1-1.3-1.5-2-.3-.5-.1-1.2.4-1.5 0 0 .1 0 .1-.1.5-.2.9-.6 1.3-.9.6-.6 1.4-1.1 2.3-1.4.4-.1.8.1 1.1.4.4.5.7 1 1 1.5.3.6 1.3 2.3 1.8 2.3.2 0 .8-.3 1.9-2.1.1-.1.1-.2.2-.3l.1-.1c1-1.5 4-6 3.2-8-.3-.6-1.7-1.1-2.8-1.5-2-.7-4.4-1.6-4.1-4 .1-1 .6-1.8 1.5-2.3 2.1-1.1 5.4.5 8.6 2.2.5.3 1 .5 1.2.6.1.1.3.1.4.2.1-.2.2-.5.2-.8s.1-.6.2-.9v-.1c.4-1.6 1.1-3.8 3.1-4.8.6-.3 1.2 0 1.5.6 0 .1 0 .1.1.2.2.9.3 1.9.2 2.8 0 .7 0 1.5.1 2.2.3 1 .1 2-.6 2.9-.2.2-.3.4-.4.7h.1c.4.2 1.6.7 1.4 2-.4 1.2-.9 2.4-1.4 3.6l-.2.3c-.7 1-1.7 1.8-2.8 2.2-.3.1-.6.3-.7.4-.2.3-.2.6-.2 1 0 .8.2 1.6.7 2.3.4.4.4 1.1 0 1.6l-.1.1c-.6.5-1.3.8-2.1.9-1 .3-1.2.4-1.3.8.4.3.8.6 1.3.8 1.2.6 2.8 1.4 2.6 3-.1.6-.6 1.1-1.2 1-.6-.1-1-.6-1-1.2-.4-.3-.9-.6-1.4-.8-1.2-.6-2.8-1.4-2.5-3.1.3-2 1.9-2.4 2.9-2.7.1 0 .2-.1.3-.1-.4-1-.6-2.1-.5-3.2 0-.9.5-1.8 1.3-2.3.3-.2.6-.3.9-.5.6-.3 1.6-.7 1.7-1.1l.2-.3c.3-.7.8-1.8 1.1-2.6-.8-.2-1.4-1-1.4-1.9.1-.8.4-1.5.8-2.1.3-.3.4-.7.2-1.1-.1-.8-.2-1.6-.2-2.4-.2.5-.3 1-.5 1.6v.1c-.1.3-.1.6-.2.8-.2 1-.4 1.9-1.3 2.3-.8.3-1.6.3-2.4-.1-.3-.1-.8-.4-1.4-.7-1.5-.8-5.3-2.8-6.5-2.2-.1 0-.2.1-.3.6-.1.6 1.1 1.1 2.7 1.6 1.7.6 3.4 1.2 4.1 2.7 1.3 3-1.8 7.8-3.3 10.1l-.1.1c-.1.1-.1.2-.2.3-.8 1.2-2.1 3.2-3.9 3.1-1.7-.1-2.7-2-3.5-3.4-.1-.2-.2-.3-.3-.4-.2.2-.5.4-.7.5-.2.2-.5.4-.8.6.2.2.4.5.6.8 1 1.2 2.2 2.6 2.3 4.3.1.5.2.9.3 1.4.4.9.5 1.9.2 2.8-.1.1-.5.4-.9.4z" />
                                                                <path fill="#001440" d="M67 77.1c-1.1 0-2.1-.2-3.1-.6-.6-.2-.9-.8-.7-1.4s.8-.9 1.4-.7c2.5.9 6.2.8 9.7-4.8 3.1-4.9 2-10.7.7-14.4-.1.2-.1.5-.2.7-1 3.4-3.9 5.8-7.4 6.4-2.7.5-4.5 1.6-5.4 3.3-1.5 3 .2 6.9.3 7.1.3.5.1 1.2-.5 1.5-.5.3-1.2.1-1.5-.4-.4-.7-2.2-5.2-.5-9 1.1-2.5 3.5-4.1 7.1-4.7 2.7-.4 4.9-2.2 5.7-4.8.4-1.3.6-2.8.6-4.2 0-.6.4-1.2 1-1.2.4 0 .8.2 1 .5 1.2 2.1 2 4.4 2.6 6.7 1.3 5.2.7 9.9-1.7 13.6-3 5.1-6.4 6.4-9.1 6.4zm-4.7-4.4c.1 0 .1 0 0 0" />
                                                                <path fill="#001440" d="M73.5 41.5H66c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h7.4c2.4 0 4.3-1.9 4.3-4.3 0-.2 0-.5-.1-.7C74.6 15.8 58.7 2.2 40 2.2c-5.8 0-11.5 1.4-16.7 3.9-4.9 2.4-9.3 5.8-12.8 10-.4.5-1.1.5-1.6.2-.5-.4-.5-1.1-.2-1.6 3.7-4.4 8.3-8 13.5-10.6C27.8 1.5 33.9 0 40 0h.1c19.8 0 36.7 14.4 39.8 34 .6 3.6-1.9 6.9-5.4 7.5h-1" />
                                                                <path fill="#001440" d="M40 67.6c-15 0-27.2-12.2-27.2-27.2S25 13.2 40 13.2s27.2 12.2 27.2 27.2c0 12.6-8.6 23.5-20.8 26.5-2.1.4-4.3.7-6.4.7m0-52.1c-2 0-4 .2-5.9.7-13.3 3.2-21.4 16.7-18.2 30s16.7 21.4 30 18.2c13.3-3.2 21.4-16.7 18.2-30C61.4 23.3 51.5 15.5 40 15.5" />
                                                                <path fill="#001440" d="M58.5 37.3c-.5 0-1.1-.1-1.6-.3-1.1-.4-2-1.3-2.2-2.5-.1-1.2.5-2.3 1.5-3 1.1-.8 2.5-1.1 3.8-.7 1.6.2 2.8 1.8 2.5 3.4-.1.8-.5 1.5-1.1 1.9-.8.8-1.8 1.2-2.9 1.2zm.3-4.4c-.5 0-.9.1-1.3.4-.4.3-.7.6-.6.9 0 .2.3.5.8.7.7.3 1.6.1 2.2-.4.2-.1.3-.3.4-.5.1-.3-.4-.8-.9-1-.2 0-.4-.1-.6-.1z" />
                                                                <path fill="#001440" d="M39.9 80.9c-19.8 0-36.7-14.4-39.8-34-.6-3.6 1.9-6.9 5.4-7.5.3-.1.7-.1 1-.1H14c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1H6.5c-2.4 0-4.3 1.9-4.3 4.3 0 .2 0 .4.1.7 3 18.5 18.9 32.1 37.6 32.1h.1c5.8 0 11.5-1.4 16.7-3.9 4.9-2.4 9.3-5.8 12.8-10 .4-.5 1.1-.5 1.6-.2.5.4.5 1.1.2 1.6-3.7 4.4-8.3 8-13.5 10.6-5.5 2.7-11.6 4.1-17.7 4.2h-.2z" />
                                                            </svg>
                                                        </div>
                                                        {/* {!dataState.sum_co2_sequestered && dataState.sum_co2_sequestered.toString() != '0' &&
                                                            <div className="text-content">
                                                                <p><strong id="totClimate">{dataState.sum_co2_sequestered.toLocaleString()}</strong>
                                                                    <span className="uppercase">TONNES OF CO2</span></p>
                                                            </div>
                                                        } */}
                                                        <div className="text-content">
                                                            {(!dataState.sum_co2_sequestered || dataState.sum_co2_sequestered.toString() == '0') ?
                                                                <p><strong id="totClimate">0,00</strong>
                                                                    <span className="uppercase">TONNES OF CO2</span></p>
                                                                :
                                                                <p><strong id="totClimate">{dataState.sum_co2_sequestered?.toLocaleString()}</strong>
                                                                    <span className="uppercase">TONNES OF CO2</span></p>
                                                            }
                                                        </div>
                                                    </div>
                                                    <br />
                                                    {/* <!-- Tools START --> */}
                                                    <div className="toolsUsedBox">
                                                        <h4 className="section-tab__item-title">{t('climate-Tools.toolusedTile')}</h4>

                                                        <div className="flex cols-3">
                                                            <div className="tile">
                                                                <h5 className="tile-title txtleft">{t('climate-Tools.FAO')}</h5>

                                                                <div className="image-wrapper">
                                                                </div>

                                                                <p className="normalPara normalParaClimate">
                                                                    {t('climate-Tools.Desc')}
                                                                </p>
                                                                <br />
                                                                <p className="graytxt">
                                                                    <a href="https://www.fao.org/in-action/epic/ex-act-tool/suite-of-tools/ex-act/en/" className="graytxt">{t('climate-Tools.More')}</a>
                                                                </p>
                                                            </div>

                                                            <div className="tile">
                                                                <h5 className="tile-title txtleft">{t('climate-Tools.IPCC')}</h5>

                                                                <div className="image-wrapper">
                                                                </div>

                                                                <p className="normalPara normalParaClimate">
                                                                    {t('climate-Tools.IPCCDesc')}
                                                                </p>
                                                                <br />
                                                                <p className="graytxt">
                                                                    <a href="https://www.ipcc-nggip.iges.or.jp/public/2019rf/pdf/4_Volume4/19R_V4_Ch04_Forest%20Land.pdf" className="graytxt">{t('climate-Tools.More')}</a>
                                                                </p>
                                                            </div>

                                                            <div className="tile">
                                                                <h5 className="tile-title txtleft">{t('climate-Tools.IUCN_WCRD')}</h5>

                                                                <div className="image-wrapper">
                                                                </div>

                                                                <p className="normalPara normalParaClimate">
                                                                    {t('climate-Tools.IUCN_WCRDDesc')}
                                                                </p>
                                                                <br />
                                                                <p className="graytxt">
                                                                    <a href="https://winrock.org/flr-calculator/?web=1&wdLOR=c41A6F7F2-C13F-44E8-88FB-33122C6427D1" className="graytxt">{t('climate-Tools.More')}</a>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Tools END  */}
                                                    <div className="tab-content__footer climate-tools">
                                                        <h5 className="tab-content__footer--title text-blue">
                                                            <span>{t('Contributed.title')}</span>
                                                        </h5>

                                                        <ul className="contributor-logos">
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                            <li>
                                                                <img className="imgPlaceHolderEmblem"></img>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                {/* {/ <!-- 6. Climate --> /} */}
                                                <span className="section-divider">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1158.003 4.003">
                                                        <path d="M0,2l521.555-.9,4.516-.008,3.763-.007L1156,0" transform="translate(1.002 1.002)" fill="none" stroke="#e5e5e5" stroke-linecap="round" stroke-width="2" stroke-dasharray="3 5" />
                                                    </svg>
                                                </span>
                                            </>
                                        }
                                        {/* <!-- 7. Biodiversity benefits start --> */}
                                        {!sectionData.biodiversity.chartConfigBiodiversity.data.datasets[0].data.every(item => item === 0) &&
                                            <div className="tab-content" id="tab-biodiversity-benefits" onMouseMove={() => showCurrentTab('tabBiodiversity', 'tab-biodiversity-benefits')}>
                                                <h3 className="lg-flex items-center text-blue tab-content__title">
                                                    <span className="flex items-center justify-center text-white indicator__counter">7</span>
                                                    <span className="text-blue indicator__text">{t('biodiversityBenefits.title')}</span>
                                                </h3>
                                                {sectionData.biodiversity.attributes.length > 0 &&
                                                    <>
                                                        <div className="chart-container" id="divBiodiversity">
                                                            <h4 className="tile-title txtleft"> {t('biodiversityBenefits.chartTile')}</h4>
                                                            <div className="col-7 chart">
                                                                {
                                                                    dataState.display_biodiversity && (sectionData.biodiversity.chartConfigBiodiversity.data.datasets[0] as any).data.length > 0 && sectionData.biodiversity.chartConfigBiodiversity.data.labels.length > 0 &&
                                                                    <Bar options={sectionData.biodiversity.chartConfigBiodiversity.options} data={sectionData.biodiversity.chartConfigBiodiversity.data} />
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="collapsable" id="divBiodiversityBenefits">
                                                            {sectionData.biodiversity.attributes.map((item, index) => {
                                                                if (item['bio_redlist'] != null)
                                                                    return (
                                                                        <div className={`collapsabel__item ${index == 0 ? "open" : (index > 4 ? "hidden" : "")}`}>
                                                                            <button type="button" className="collapsabel__item__header" onClick={() => openPolicyTab(index, 'divBiodiversityBenefits')}>
                                                                                <span className="tile-title">
                                                                                </span>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.225 13.615">
                                                                                    <path d="m26.11 2.115-11.719 10-12.281-10" fill="none" stroke="#197058" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                                                                                </svg>
                                                                            </button>

                                                                            <div className={`collapsabel__item__body ${index == 0 ? "heightAutoAccordion" : "heightAccordion"}`}>
                                                                                <div>
                                                                                    <ul>
                                                                                        <li>
                                                                                            <strong>{t('biodiversityBenefits.RedListTitle')}</strong> <span className="normaltxt">{item['bio_redlist']}</span>
                                                                                        </li>
                                                                                    </ul>
                                                                                    <p>
                                                                                        <strong>{t('biodiversityBenefits.Ref')}</strong><span className="normaltxt"> {item['bio_information']}</span>
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                            })
                                                            }
                                                            {sectionData.biodiversity.attributes.length > 4 && sectionData.biodiversity.attributes.map((item, index) => {
                                                                if (item['bio_redlist'] != null)
                                                                    <button type="button" className="btn-view-more" onClick={() => viewMoreDetails('divBiodiversityBenefits')}>View more</button>
                                                            })
                                                            }
                                                        </div>
                                                    </>
                                                }
                                                <div className="tab-content__footer">
                                                    <h5 className="tab-content__footer--title text-blue">
                                                        <span>{t('Contributed.title')}</span>
                                                    </h5>

                                                    <ul className="contributor-logos">
                                                        <li>
                                                            <img className="imgPlaceHolderEmblem" />
                                                        </li>
                                                        <li>
                                                            <img className="imgPlaceHolderEmblem" />
                                                        </li>
                                                        <li>
                                                            <img className="imgPlaceHolderEmblem" />
                                                        </li>
                                                    </ul>
                                                </div>

                                            </div>
                                        }

                                        {/* <!-- 7. Biodiversity benefits end --> */}

                                        {/* {/ <!-- 8. Economy start --> /} */}
                                        {sectionData.economy.attributes.length > 0 && dataState.sum_eco_jobs_created && dataState.sum_eco_jobs_created != 0 &&
                                            <div className="tab-content" id="tab-economy" onMouseMove={() => showCurrentTab('tabEconomy', 'tab-economy')}>
                                                <h3 className="lg-flex items-center text-blue tab-content__title">
                                                    <span className="flex items-center justify-center text-white indicator__counter">8</span>
                                                    <span className="text-blue indicator__text">{t('economy.title')}</span>
                                                </h3>

                                                <div className="yellow-badge">
                                                    <div className="illustration">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.94 84.299">
                                                            <defs>
                                                                <clipPath id="economy_a">
                                                                    <path fill="none" d="M0 0h78.94v84.3H0z" />
                                                                </clipPath>
                                                            </defs>
                                                            <g clip-path="url(#economy_a)">
                                                                <path d="m56.549 44-6.8 6.8A35.349 35.349 0 0 0 0 82.846v.225A1.225 1.225 0 0 0 1.226 84.3h68.228a1.226 1.226 0 0 0 1.226-1.226 35.31 35.31 0 0 0-15.138-28.992l5.545-5.546 1.588 1.588a6.682 6.682 0 0 0 9.447 0l6.461-6.46a1.226 1.226 0 0 0-1.734-1.733l-6.46 6.46a4.23 4.23 0 0 1-5.98 0l-2.99-2.99 9.738-9.738a1.226 1.226 0 1 0-1.733-1.734l-9.739 9.738-2.989-2.99a4.229 4.229 0 0 1 0-5.979l6.46-6.461a1.228 1.228 0 1 0-1.735-1.737l-6.46 6.46a6.683 6.683 0 0 0 0 9.447Zm.324 14.224a32.819 32.819 0 0 1 11.332 23.625H56.873Zm-10.364-6.09-10.052 25.8a1.225 1.225 0 0 1-2.284 0L24.13 52.148a32.789 32.789 0 0 0-7.872 4.143v25.558h38.164V56.292a32.788 32.788 0 0 0-7.913-4.157m-32.7 6.089v23.625H2.475a32.813 32.813 0 0 1 11.331-23.626m30.364-6.836-8.854 22.725L26.468 51.4a33.059 33.059 0 0 1 17.7-.012m9.267 1.334 5.919-5.922-1.072-1.072-6.212 6.216q.693.373 1.366.776M19.892 11.564H15.1a1.227 1.227 0 0 0-.809.3L1.239 23.333a1.226 1.226 0 0 0 .809 2.146H16.69v.071a18.651 18.651 0 0 0 37.3 0v-.071h14.642a1.226 1.226 0 0 0 .81-2.145L56.434 11.871a1.223 1.223 0 0 0-.81-.306h-4.849a16.092 16.092 0 0 0-30.883 0m31.646 13.914H19.14v.071a16.2 16.2 0 0 0 32.4 0v-.071m13.849-2.451H5.3l10.259-9.012h39.6ZM48.2 11.564a13.64 13.64 0 0 0-25.734 0Z" fill="#001440" fill-rule="evenodd" />
                                                            </g>
                                                        </svg>
                                                    </div>

                                                    <div className="text-content">
                                                        {
                                                            sectionData.economy.attributes.length > 0 && dataState.sum_eco_jobs_created &&
                                                            <p><strong id="totJobs">{dataState.sum_eco_jobs_created.toLocaleString()}</strong>
                                                                <span className="uppercase">{t('economy.totalJobsCreated')}</span></p>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="collapsable" id="divEconomy">
                                                    {
                                                        sectionData.economy.attributes.length > 0 && dataState.sum_eco_jobs_created &&
                                                        sectionData.economy.attributes.map((item, index) => {
                                                            return (
                                                                <div className={`collapsabel__item ${index == 0 ? "open" : (index > 4 ? "hidden" : "")}`}>
                                                                    <button type="button" className="collapsabel__item__header" onClick={() => openPolicyTab(index, 'divEconomy')}>
                                                                        <span className="tile-title">{item['eco_type']}
                                                                            {item['eco_unit'] != null && item['eco_unit'] != '' &&
                                                                                <>
                                                                                    &nbsp;- {item['eco_unit']}
                                                                                </>
                                                                            }
                                                                            {item['eco_tiers'] != null && item['eco_tiers'] != '' &&
                                                                                <>
                                                                                    &nbsp;- {item['eco_tiers']}
                                                                                </>
                                                                            }
                                                                        </span>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.225 13.615">
                                                                            <path d="m26.11 2.115-11.719 10-12.281-10" fill="none" stroke="#197058" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                                                                        </svg>
                                                                    </button>

                                                                    <div className={`collapsabel__item__body ${index == 0 ? "heightAutoAccordion" : "heightAccordion"}`}>
                                                                        <div>

                                                                            <ul>
                                                                                {item['eco_jobs'] != null && item['eco_jobs'] != '' && item['eco_jobs'] != "0" &&
                                                                                    <li>
                                                                                        <strong>{t('economy.noofJobsCreated')}</strong> <span className="normaltxt">{item['eco_jobs']}</span>
                                                                                    </li>
                                                                                }
                                                                            </ul>
                                                                            {/* <p>
                                                                                <strong>{t('economy.Ref')}</strong><span className="normaltxt"></span>
                                                                            </p> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    {sectionData.economy.attributes.length > 4 &&
                                                        (
                                                            <button type="button" className="btn-view-more" onClick={() => viewMoreDetails('divEconomy')}>View more</button>
                                                        )
                                                    }
                                                </div>
                                                <div className="tab-content__footer">
                                                    <h5 className="tab-content__footer--title text-blue">
                                                        <span>{t('Contributed.title')}</span>
                                                    </h5>

                                                    <ul className="contributor-logos">
                                                        <li>
                                                            <img className="imgPlaceHolderEmblem"></img>
                                                        </li>
                                                        <li>
                                                            <img className="imgPlaceHolderEmblem"></img>
                                                        </li>
                                                        <li>
                                                            <img className="imgPlaceHolderEmblem"></img>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        }
                                        {/* {/ <!-- <!-- 8. Economy  end --> /} */}
                                    </div>
                                </div>

                            </div>

                        </div>
                    </>
                }
            </div>

            <LoadingOverlay
                active={state.loading}
                spinner
                text={state.loading ? t('loading') : ''} >
            </LoadingOverlay>
        </>
    )

};

export default DetailDashboard;